var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _g2, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _rect2, _rect3, _rect4, _path483, _path484, _path485, _g3, _path486, _g4, _path487, _path488, _g5, _path489, _path490, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionLoadingBottomBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 280,
    viewBox: "0 0 375 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9862_162966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 280
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 280,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9862_162966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.98828 105C-8.98828 105 114.368 202.5 189.001 159C263.634 115.5 351.863 118.5 390.324 178.5C428.785 238.5 368 313.77 376 313C384 312.23 -1 297.23 -1 297.23L-8.98828 105Z",
    fill: "url(#paint0_linear_9862_162966)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127 172H128V87H127V172Z",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.788 144L128 143.212L139.212 132L140 132.788L128.788 144Z",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.802 114L128 113.198L134.198 107L135 107.802L128.802 114Z",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.203 129L118 119.797L118.797 119L128 128.203L127.203 129Z",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.298 101L123 96.7016L123.702 96L128 100.298L127.298 101Z",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.291 206.553C-15.291 206.553 23 190.303 47 202.078C71 213.853 95.0471 227.121 149.809 233.326C204.57 239.531 221.545 264.225 225.084 264.225C228.623 264.225 -8.98828 264.225 -8.98828 264.225L-15.291 206.553Z",
    fill: "url(#paint1_linear_9862_162966)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.835 206.553C393.835 206.553 366.137 175.484 330.516 196.5C294.895 217.516 261.001 226.379 236.422 226.379C211.842 226.379 182.597 264.225 179.058 264.225C175.519 264.225 387.532 264.225 387.532 264.225L393.835 206.553Z",
    fill: "url(#paint2_linear_9862_162966)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.605 246.069C398.605 246.069 374.907 215.904 334.92 213.904C294.933 211.904 246.259 269.336 187.714 250.199C129.168 231.063 89.5 250.199 9.45312 237C-70.5938 223.801 9.45312 304 9.45312 304H407.914L398.605 246.069Z",
    fill: "url(#paint3_linear_9862_162966)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.156 189.44C334.394 191.523 329.896 193.491 326.843 191.835C323.625 190.083 320.688 189.704 318.349 190.736C315.544 191.975 313.608 195.16 312.601 200.203C311.528 205.556 305.707 205.831 299.545 206.123C292.649 206.448 285.521 206.788 284.476 214.334C283.607 220.618 278.874 224.577 274.699 228.071C271.46 230.783 268.66 233.122 268.742 235.844C268.798 237.787 270.352 239.9 273.483 242.298C274.616 241.569 279.755 238.714 288.439 240.479C290.661 240.927 292.342 241.467 293.693 241.899C295.526 242.488 296.631 242.843 297.428 242.441C298.558 241.874 299.371 239.662 300.887 234.599C302.787 228.253 310.186 226.521 316.715 224.996C322.653 223.605 327.785 222.405 327.82 218.233C327.82 218.173 327.823 218.117 327.826 218.056C328.045 213.448 335.11 207.476 341.946 201.696C347.843 196.709 353.405 192 353.442 189.068C353.448 188.486 353.224 188 352.759 187.587C349.666 184.842 344.322 187.178 339.156 189.44Z",
    fill: "#74D1D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.516 237.524C278.103 240.53 281.275 235.374 284.341 230.387C286.85 226.312 289.217 222.463 296.104 223.001C305.235 223.715 308.843 217.911 312.027 212.792C314.397 208.984 316.636 205.387 320.821 205.033C330.894 204.182 343.756 195.937 343.884 195.854L343.481 195.284C343.355 195.367 330.644 203.514 320.756 204.349C316.205 204.734 313.877 208.477 311.412 212.44C308.183 217.629 304.846 222.996 296.159 222.316C288.825 221.743 286.234 225.96 283.725 230.037C280.659 235.023 277.76 239.731 266.701 236.863L266.516 237.524Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.131 153.013C310.55 158.487 309.056 163.657 311.478 166.645C314.035 169.795 314.969 172.879 314.182 175.572C313.237 178.797 309.912 181.429 304.296 183.39C298.335 185.473 299.011 191.769 299.722 198.433C300.523 205.892 301.345 213.602 292.862 216.039C285.8 218.065 282.062 223.835 278.762 228.926C276.2 232.875 273.991 236.288 270.855 236.673C268.614 236.952 265.926 235.653 262.642 232.71C263.285 231.367 265.686 225.354 262.185 216.341C261.292 214.033 260.388 212.324 259.662 210.949C258.675 209.085 258.078 207.96 258.406 207.036C258.865 205.723 261.263 204.464 266.816 201.955C273.775 198.811 274.505 190.568 275.145 183.295C275.73 176.678 276.235 170.962 281.018 170.197C281.086 170.186 281.149 170.174 281.219 170.16C286.47 169.121 292.121 160.497 297.591 152.154C302.31 144.956 306.77 138.166 310.128 137.614C310.796 137.507 311.391 137.663 311.945 138.089C315.619 140.932 313.847 147.073 312.131 153.013Z",
    fill: "#008D84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.076 239.868C263.687 228.027 269.041 223.748 274.221 219.609C278.453 216.226 282.451 213.03 280.673 205.777C278.317 196.16 284.336 191.3 289.647 187.015C293.598 183.824 297.328 180.811 297.027 176.285C296.298 165.389 303.547 150.234 303.621 150.082L304.338 150.414C304.264 150.563 297.104 165.539 297.819 176.234C298.148 181.155 294.264 184.291 290.153 187.61C284.771 191.955 279.203 196.45 281.445 205.6C283.338 213.324 278.96 216.823 274.724 220.207C269.547 224.345 264.657 228.255 269.802 239.556L269.076 239.868Z",
    fill: "#74D1D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.889 238.619V242.038C180.889 242.31 180.79 242.561 180.62 242.773C180.441 242.994 180.184 243.168 179.883 243.265C179.793 243.296 179.696 243.318 179.597 243.334C179.506 243.348 179.415 243.354 179.32 243.354H114.48C113.645 243.354 112.957 242.798 112.914 242.105C112.914 242.083 112.912 242.059 112.912 242.038V238.619C112.912 238.596 112.914 238.574 112.914 238.55C112.957 237.857 113.645 237.302 114.48 237.302H179.32C179.415 237.302 179.506 237.31 179.597 237.323C179.696 237.337 179.793 237.359 179.883 237.391C180.184 237.487 180.441 237.661 180.62 237.883C180.79 238.094 180.889 238.347 180.889 238.619Z",
    fill: "#FFB93E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.049 243.354H114.312C113.568 243.354 112.953 242.798 112.914 242.105C112.914 242.083 112.912 242.059 112.912 242.038V238.619C112.912 238.596 112.914 238.574 112.914 238.55C112.953 237.857 113.568 237.302 114.312 237.302H144.783C145.271 239.084 146.405 241.548 149.049 243.354Z",
    fill: "#FFA412"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.262 243.354H172.999V237.302H172.262V243.354Z",
    fill: "#FFA412"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.769 243.354H170.506V237.302H169.769V243.354Z",
    fill: "#FFA412"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.777 243.354H167.514V237.302H166.777V243.354Z",
    fill: "#FFA412"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.19 243.354H162.929V237.302H162.19V243.354Z",
    fill: "#FFA412"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.344 243.354H158.081V237.302H157.344V243.354Z",
    fill: "#FFA412"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.908 243.354H150.645V237.302H149.908V243.354Z",
    fill: "#FFA412"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.951 243.354H143.688V237.302H142.951V243.354Z",
    fill: "#FFA412"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.735 243.354H137.472V237.302H136.735V243.354Z",
    fill: "#FFA412"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.634 243.354H175.371V237.302H174.634V243.354Z",
    fill: "#FFA412"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.206 243.354H176.943V237.302H176.206V243.354Z",
    fill: "#FFA412"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.718 243.354H178.455V237.302H177.718V243.354Z",
    fill: "#FFA412"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.595 237.323V243.334C179.504 243.348 179.413 243.354 179.319 243.354H178.858V237.302H179.319C179.413 237.302 179.504 237.31 179.595 237.323Z",
    fill: "#FFA412"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.619 237.883V242.773C180.439 242.994 180.182 243.168 179.882 243.265V237.391C180.182 237.488 180.439 237.662 180.619 237.883Z",
    fill: "#FFA412"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.957 232.563V235.981C173.957 236.254 173.858 236.507 173.688 236.716C173.51 236.937 173.254 237.111 172.951 237.21C172.86 237.24 172.764 237.263 172.665 237.277C172.576 237.291 172.483 237.299 172.388 237.299H107.55C106.714 237.299 106.025 236.742 105.983 236.048C105.981 236.027 105.981 236.005 105.981 235.981V232.563C105.981 232.541 105.981 232.518 105.983 232.496C106.025 231.802 106.714 231.245 107.55 231.245H172.388C172.43 231.245 172.471 231.247 172.513 231.249L172.566 231.255C172.584 231.255 172.604 231.257 172.623 231.261L172.665 231.267C172.764 231.281 172.86 231.304 172.951 231.334L172.993 231.348L173.032 231.364C173.058 231.374 173.086 231.383 173.111 231.395L173.157 231.415L173.196 231.435C173.222 231.449 173.246 231.46 173.271 231.474C173.299 231.49 173.325 231.508 173.35 231.526C173.372 231.538 173.392 231.551 173.412 231.567L173.416 231.569L173.455 231.599C173.495 231.63 173.534 231.664 173.568 231.698L173.599 231.729L173.631 231.761C173.651 231.783 173.67 231.804 173.688 231.828C173.858 232.037 173.957 232.29 173.957 232.563Z",
    fill: "#FFB93E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.119 237.299H107.382C106.635 237.299 106.021 236.742 105.983 236.048C105.981 236.027 105.981 236.005 105.981 235.981V232.563C105.981 232.541 105.981 232.518 105.983 232.496C106.021 231.802 106.635 231.245 107.382 231.245H137.851C137.865 231.295 137.879 231.344 137.895 231.395C138.402 233.164 139.544 235.542 142.119 237.299Z",
    fill: "#FFA412"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.329 237.299H166.066V231.245H165.329V237.299Z",
    fill: "#FFA412"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.835 237.299H163.572V231.245H162.835V237.299Z",
    fill: "#FFA412"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.842 237.299H160.579V231.245H159.842V237.299Z",
    fill: "#FFA412"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.257 237.299H155.994V231.245H155.257V237.299Z",
    fill: "#FFA412"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.41 237.299H151.147V231.245H150.41V237.299Z",
    fill: "#FFA412"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.978 237.299H143.715V231.245H142.978V237.299Z",
    fill: "#FFA412"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.015 237.299H136.752V231.245H136.015V237.299Z",
    fill: "#FFA412"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.801 237.299H130.538V231.245H129.801V237.299Z",
    fill: "#FFA412"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.707 237.299H168.444V231.245H167.707V237.299Z",
    fill: "#FFA412"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.272 237.299H170.009V231.245H169.272V237.299Z",
    fill: "#FFA412"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.788 237.299H171.525V231.245H170.788V237.299Z",
    fill: "#FFA412"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.663 231.267V237.277C172.572 237.291 172.481 237.299 172.386 237.299H171.926V231.245H172.386C172.481 231.245 172.572 231.253 172.663 231.267Z",
    fill: "#FFA412"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.688 231.827V236.715C173.511 236.937 173.254 237.111 172.951 237.209V231.333C173.254 231.43 173.511 231.606 173.688 231.827Z",
    fill: "#FFA412"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.306 226.66V230.079C177.306 230.351 177.207 230.604 177.037 230.814C176.858 231.035 176.601 231.209 176.3 231.307C176.208 231.337 176.113 231.361 176.014 231.375C175.923 231.388 175.832 231.396 175.737 231.396H110.897C110.639 231.396 110.392 231.341 110.174 231.246C109.716 231.045 109.388 230.657 109.337 230.205C109.335 230.185 109.333 230.165 109.331 230.146C109.331 230.124 109.329 230.1 109.329 230.079V226.66C109.329 226.639 109.331 226.615 109.331 226.593C109.374 225.9 110.062 225.343 110.897 225.343H175.737C175.832 225.343 175.923 225.35 176.014 225.364C176.113 225.378 176.208 225.402 176.3 225.431C176.601 225.528 176.858 225.704 177.037 225.925C177.207 226.135 177.306 226.388 177.306 226.66Z",
    fill: "#FFB93E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.466 231.396H110.729C110.496 231.396 110.277 231.341 110.085 231.246C109.674 231.045 109.382 230.657 109.337 230.205C109.335 230.185 109.333 230.165 109.331 230.146C109.331 230.124 109.329 230.1 109.329 230.079V226.66C109.329 226.639 109.331 226.615 109.331 226.593C109.368 225.9 109.985 225.343 110.729 225.343H141.2C141.674 227.075 142.759 229.454 145.253 231.246C145.324 231.298 145.395 231.347 145.466 231.396Z",
    fill: "#FFA412"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.68 231.396H169.417V225.343H168.68V231.396Z",
    fill: "#FFA412"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.185 231.396H166.922V225.343H166.185V231.396Z",
    fill: "#FFA412"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.194 231.396H163.931V225.343H163.194V231.396Z",
    fill: "#FFA412"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.607 231.396H159.344V225.343H158.607V231.396Z",
    fill: "#FFA412"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.761 231.396H154.498V225.343H153.761V231.396Z",
    fill: "#FFA412"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.327 231.396H147.064V225.343H146.327V231.396Z",
    fill: "#FFA412"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.366 231.396H140.103V225.343H139.366V231.396Z",
    fill: "#FFA412"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.151 231.396H133.888V225.343H133.151V231.396Z",
    fill: "#FFA412"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.052 231.396H171.789V225.343H171.052V231.396Z",
    fill: "#FFA412"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.622 231.396H173.359V225.343H172.622V231.396Z",
    fill: "#FFA412"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.137 231.396H174.874V225.343H174.137V231.396Z",
    fill: "#FFA412"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.015 225.364V231.375C175.924 231.388 175.834 231.396 175.739 231.396H175.278V225.343H175.739C175.834 225.343 175.924 225.35 176.015 225.364Z",
    fill: "#FFA412"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.039 225.925V230.813C176.859 231.034 176.602 231.208 176.302 231.307V225.431C176.602 225.528 176.859 225.704 177.039 225.925Z",
    fill: "#FFA412"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.86 220.607V224.025C178.86 224.298 178.761 224.551 178.591 224.762C178.411 224.983 178.154 225.157 177.854 225.254C177.763 225.286 177.666 225.307 177.568 225.323C177.477 225.335 177.386 225.343 177.291 225.343H112.451C111.615 225.343 110.928 224.788 110.884 224.094C110.884 224.07 110.882 224.049 110.882 224.025V220.607C110.882 220.585 110.884 220.561 110.884 220.54C110.924 219.898 111.517 219.374 112.265 219.299C112.327 219.293 112.388 219.291 112.451 219.291H177.291C177.386 219.291 177.477 219.297 177.568 219.311C177.666 219.327 177.763 219.348 177.854 219.378C178.154 219.477 178.411 219.651 178.591 219.872C178.761 220.083 178.86 220.334 178.86 220.607Z",
    fill: "#FFB93E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.02 225.343H112.283C111.538 225.343 110.924 224.788 110.884 224.094C110.884 224.07 110.882 224.049 110.882 224.025V220.607C110.882 220.585 110.884 220.561 110.884 220.54C110.92 219.9 111.449 219.374 112.117 219.299C112.173 219.293 112.228 219.291 112.283 219.291H142.754L142.758 219.299C143.246 221.081 144.38 223.539 147.02 225.343Z",
    fill: "#FFA412"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.234 225.342H170.971V219.288H170.234V225.342Z",
    fill: "#FFA412"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.737 225.342H168.474V219.288H167.737V225.342Z",
    fill: "#FFA412"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.748 225.342H165.485V219.288H164.748V225.342Z",
    fill: "#FFA412"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.162 225.342H160.897V219.288H160.162V225.342Z",
    fill: "#FFA412"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.315 225.342H156.05V219.288H155.315V225.342Z",
    fill: "#FFA412"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.878 225.342H148.615V219.288H147.878V225.342Z",
    fill: "#FFA412"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.92 225.342H141.657V219.288H140.92V225.342Z",
    fill: "#FFA412"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.708 225.342H135.445V219.288H134.708V225.342Z",
    fill: "#FFA412"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.608 225.342H173.345V219.288H172.608V225.342Z",
    fill: "#FFA412"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.174 225.342H174.911V219.288H174.174V225.342Z",
    fill: "#FFA412"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.691 225.342H176.428V219.288H175.691V225.342Z",
    fill: "#FFA412"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.568 219.31V225.32C177.477 225.334 177.386 225.342 177.291 225.342H176.831V219.288H177.291C177.386 219.288 177.477 219.296 177.568 219.31Z",
    fill: "#FFA412"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.591 219.87V224.76C178.412 224.982 178.155 225.156 177.854 225.252V219.376C178.155 219.475 178.412 219.649 178.591 219.87Z",
    fill: "#FFA412"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.091 214.563V217.983C174.091 218.254 173.993 218.506 173.823 218.718C173.645 218.939 173.388 219.113 173.086 219.21C172.995 219.241 172.898 219.263 172.799 219.279C172.77 219.283 172.738 219.287 172.708 219.291L172.657 219.295L172.606 219.297C172.578 219.299 172.55 219.299 172.523 219.299H107.685C106.849 219.299 106.159 218.744 106.118 218.05C106.116 218.026 106.116 218.005 106.116 217.983V214.563C106.116 214.541 106.116 214.519 106.118 214.496C106.118 214.478 106.12 214.458 106.122 214.44C106.183 213.883 106.665 213.423 107.297 213.286L107.345 213.278C107.454 213.257 107.568 213.247 107.685 213.247H172.523C172.57 213.247 172.618 213.249 172.663 213.251C172.685 213.253 172.704 213.255 172.726 213.257C172.75 213.261 172.776 213.265 172.799 213.267C172.898 213.282 172.995 213.304 173.086 213.336C173.388 213.433 173.645 213.606 173.823 213.828C173.993 214.039 174.091 214.292 174.091 214.563Z",
    fill: "#FFB93E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.251 219.299H107.517C106.77 219.299 106.155 218.744 106.118 218.05C106.116 218.026 106.116 218.005 106.116 217.983V214.563C106.116 214.541 106.116 214.519 106.118 214.496C106.118 214.478 106.12 214.458 106.122 214.44C106.177 213.871 106.626 213.403 107.209 213.278C107.228 213.274 107.248 213.271 107.268 213.267C107.349 213.253 107.432 213.247 107.517 213.247H137.986L138 213.288C138.491 215.065 139.626 217.499 142.238 219.291L142.251 219.299Z",
    fill: "#FFA412"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.466 219.299H166.203V213.247H165.466V219.299Z",
    fill: "#FFA412"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.97 219.299H163.707V213.247H162.97V219.299Z",
    fill: "#FFA412"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.98 219.299H160.717V213.247H159.98V219.299Z",
    fill: "#FFA412"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.396 219.299H156.133V213.247H155.396V219.299Z",
    fill: "#FFA412"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.549 219.299H151.286V213.247H150.549V219.299Z",
    fill: "#FFA412"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.115 219.299H143.852V213.247H143.115V219.299Z",
    fill: "#FFA412"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.152 219.299H136.889V213.247H136.152V219.299Z",
    fill: "#FFA412"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.94 219.299H130.677V213.247H129.94V219.299Z",
    fill: "#FFA412"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.841 219.299H168.578V213.247H167.841V219.299Z",
    fill: "#FFA412"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.409 219.299H170.146V213.247H169.409V219.299Z",
    fill: "#FFA412"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.922 219.299H171.659V213.247H170.922V219.299Z",
    fill: "#FFA412"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.8 213.267V219.279C172.71 219.293 172.619 219.299 172.524 219.299H172.063V213.247H172.524C172.619 213.247 172.71 213.253 172.8 213.267Z",
    fill: "#FFA412"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.824 213.826V218.716C173.646 218.937 173.389 219.111 173.087 219.208V213.334C173.389 213.431 173.646 213.605 173.824 213.826Z",
    fill: "#FFA412"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.957 208.553V211.971C173.957 212.244 173.858 212.495 173.688 212.706C173.51 212.927 173.254 213.101 172.951 213.2C172.88 213.224 172.805 213.241 172.728 213.255H172.726C172.706 213.259 172.687 213.263 172.665 213.267C172.576 213.281 172.483 213.287 172.388 213.287H107.55C107.481 213.287 107.412 213.285 107.347 213.277C107.321 213.273 107.295 213.271 107.27 213.265C106.564 213.158 106.021 212.653 105.983 212.038C105.981 212.016 105.981 211.993 105.981 211.971V208.553C105.981 208.529 105.981 208.507 105.983 208.484C106.025 207.79 106.714 207.235 107.55 207.235H172.388C172.43 207.235 172.471 207.237 172.513 207.239L172.566 207.243C172.584 207.245 172.604 207.247 172.623 207.251L172.665 207.257C172.764 207.271 172.86 207.292 172.951 207.324L172.993 207.338L173.032 207.352C173.06 207.361 173.086 207.373 173.111 207.383C173.141 207.397 173.169 207.411 173.196 207.425C173.222 207.437 173.246 207.45 173.271 207.464C173.299 207.48 173.325 207.498 173.35 207.514C173.372 207.527 173.392 207.541 173.412 207.555L173.416 207.559L173.455 207.589C173.495 207.62 173.534 207.652 173.568 207.687L173.599 207.717L173.631 207.749C173.651 207.77 173.67 207.794 173.688 207.816C173.858 208.027 173.957 208.28 173.957 208.553Z",
    fill: "#FFB93E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.119 213.287H107.382C107.355 213.287 107.327 213.287 107.299 213.285C107.27 213.285 107.24 213.281 107.21 213.277C106.543 213.2 106.017 212.678 105.983 212.038C105.981 212.016 105.981 211.993 105.981 211.971V208.553C105.981 208.529 105.981 208.507 105.983 208.484C106.021 207.79 106.635 207.235 107.382 207.235H137.851C137.865 207.284 137.879 207.334 137.895 207.383C138.398 209.138 139.527 211.493 142.056 213.245C142.077 213.259 142.097 213.273 142.119 213.287Z",
    fill: "#FFA412"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.329 213.289H166.066V207.235H165.329V213.289Z",
    fill: "#FFA412"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.835 213.289H163.572V207.235H162.835V213.289Z",
    fill: "#FFA412"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.842 213.289H160.579V207.235H159.842V213.289Z",
    fill: "#FFA412"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.257 213.289H155.994V207.235H155.257V213.289Z",
    fill: "#FFA412"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.41 213.289H151.147V207.235H150.41V213.289Z",
    fill: "#FFA412"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.978 213.289H143.715V207.235H142.978V213.289Z",
    fill: "#FFA412"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.015 213.289H136.752V207.235H136.015V213.289Z",
    fill: "#FFA412"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.801 213.289H130.538V207.235H129.801V213.289Z",
    fill: "#FFA412"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.707 213.289H168.444V207.235H167.707V213.289Z",
    fill: "#FFA412"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.272 213.289H170.009V207.235H169.272V213.289Z",
    fill: "#FFA412"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.788 213.289H171.525V207.235H170.788V213.289Z",
    fill: "#FFA412"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.663 207.257V213.267C172.572 213.281 172.481 213.287 172.386 213.287H171.926V207.235H172.386C172.481 207.235 172.572 207.243 172.663 207.257Z",
    fill: "#FFA412"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.688 207.815V212.705C173.511 212.926 173.254 213.1 172.951 213.199V207.323C173.254 207.42 173.511 207.594 173.688 207.815Z",
    fill: "#FFA412"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.306 202.65V206.068C177.306 206.339 177.207 206.592 177.037 206.803C176.858 207.025 176.601 207.198 176.3 207.295C176.208 207.327 176.113 207.349 176.014 207.364C175.923 207.378 175.832 207.384 175.737 207.384H110.897C110.639 207.384 110.392 207.331 110.174 207.236C109.716 207.034 109.388 206.647 109.337 206.195C109.335 206.175 109.333 206.155 109.331 206.135C109.331 206.114 109.329 206.09 109.329 206.068V202.65C109.329 202.626 109.331 202.605 109.331 202.581C109.374 201.887 110.062 201.332 110.897 201.332H175.737C175.832 201.332 175.923 201.34 176.014 201.354C176.113 201.368 176.208 201.39 176.3 201.421C176.601 201.518 176.858 201.692 177.037 201.913C177.207 202.125 177.306 202.377 177.306 202.65Z",
    fill: "#FFB93E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.466 207.384H110.729C110.496 207.384 110.277 207.331 110.085 207.236C109.674 207.034 109.382 206.647 109.337 206.195C109.335 206.175 109.333 206.155 109.331 206.135C109.331 206.114 109.329 206.09 109.329 206.068V202.65C109.329 202.626 109.331 202.605 109.331 202.581C109.368 201.887 109.985 201.332 110.729 201.332H141.2C141.674 203.065 142.759 205.444 145.253 207.236C145.324 207.285 145.395 207.335 145.466 207.384Z",
    fill: "#FFA412"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.68 207.386H169.417V201.332H168.68V207.386Z",
    fill: "#FFA412"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.185 207.386H166.922V201.332H166.185V207.386Z",
    fill: "#FFA412"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.194 207.386H163.931V201.332H163.194V207.386Z",
    fill: "#FFA412"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.607 207.386H159.344V201.332H158.607V207.386Z",
    fill: "#FFA412"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.761 207.386H154.498V201.332H153.761V207.386Z",
    fill: "#FFA412"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.327 207.386H147.064V201.332H146.327V207.386Z",
    fill: "#FFA412"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.366 207.386H140.103V201.332H139.366V207.386Z",
    fill: "#FFA412"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.151 207.386H133.888V201.332H133.151V207.386Z",
    fill: "#FFA412"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.052 207.386H171.789V201.332H171.052V207.386Z",
    fill: "#FFA412"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.622 207.386H173.359V201.332H172.622V207.386Z",
    fill: "#FFA412"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.137 207.386H174.874V201.332H174.137V207.386Z",
    fill: "#FFA412"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.015 201.354V207.364C175.924 207.378 175.834 207.384 175.739 207.384H175.278V201.332H175.739C175.834 201.332 175.924 201.34 176.015 201.354Z",
    fill: "#FFA412"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.039 201.913V206.803C176.859 207.024 176.602 207.198 176.302 207.297V201.421C176.602 201.517 176.859 201.691 177.039 201.913Z",
    fill: "#FFA412"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.603 196.595V200.013C182.603 200.286 182.504 200.539 182.334 200.748C182.157 200.97 181.9 201.144 181.6 201.242C181.507 201.272 181.41 201.296 181.311 201.31C181.222 201.323 181.129 201.331 181.034 201.331H116.196C115.361 201.331 114.671 200.774 114.63 200.081C114.628 200.059 114.628 200.037 114.628 200.013V196.595C114.628 196.574 114.628 196.55 114.63 196.528C114.669 195.886 115.26 195.362 116.011 195.287C116.072 195.281 116.133 195.277 116.196 195.277H181.034C181.129 195.277 181.222 195.285 181.311 195.299C181.41 195.313 181.507 195.337 181.6 195.366C181.9 195.465 182.157 195.639 182.334 195.86C182.504 196.07 182.603 196.323 182.603 196.595Z",
    fill: "#FFB93E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.765 201.331H116.029C115.282 201.331 114.667 200.774 114.63 200.081C114.628 200.059 114.628 200.037 114.628 200.013V196.595C114.628 196.574 114.628 196.55 114.63 196.528C114.663 195.886 115.193 195.362 115.863 195.287C115.916 195.281 115.971 195.277 116.029 195.277H146.499L146.501 195.287C146.989 197.07 148.123 199.527 150.765 201.331Z",
    fill: "#FFA412"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.979 201.331H174.716V195.277H173.979V201.331Z",
    fill: "#FFA412"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.483 201.331H172.22V195.277H171.483V201.331Z",
    fill: "#FFA412"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.493 201.331H169.23V195.277H168.493V201.331Z",
    fill: "#FFA412"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.906 201.331H164.643V195.277H163.906V201.331Z",
    fill: "#FFA412"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.058 201.331H159.795V195.277H159.058V201.331Z",
    fill: "#FFA412"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.626 201.331H152.363V195.277H151.626V201.331Z",
    fill: "#FFA412"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.667 201.331H145.403V195.277H144.667V201.331Z",
    fill: "#FFA412"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.452 201.331H139.187V195.277H138.452V201.331Z",
    fill: "#FFA412"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.351 201.331H177.088V195.277H176.351V201.331Z",
    fill: "#FFA412"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.923 201.331H178.66V195.277H177.923V201.331Z",
    fill: "#FFA412"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.435 201.331H180.172V195.277H179.435V201.331Z",
    fill: "#FFA412"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.313 195.299V201.31C181.222 201.323 181.129 201.331 181.037 201.331H180.576V195.277H181.037C181.129 195.277 181.222 195.285 181.313 195.299Z",
    fill: "#FFA412"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.337 195.863V200.752C182.157 200.973 181.9 201.147 181.6 201.246V195.37C181.9 195.468 182.157 195.642 182.337 195.863Z",
    fill: "#FFA412"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.091 190.554V193.972C174.091 194.245 173.993 194.498 173.823 194.707C173.645 194.93 173.388 195.104 173.086 195.201C172.995 195.233 172.898 195.254 172.799 195.268C172.77 195.274 172.738 195.278 172.708 195.28C172.685 195.284 172.659 195.284 172.635 195.286L172.6 195.288C172.574 195.29 172.548 195.29 172.523 195.29H107.685C106.849 195.29 106.159 194.733 106.118 194.039C106.116 194.018 106.116 193.996 106.116 193.972V190.554C106.116 190.532 106.116 190.509 106.118 190.487C106.159 189.793 106.849 189.236 107.685 189.236H172.523C172.55 189.236 172.578 189.238 172.606 189.24C172.673 189.242 172.736 189.248 172.799 189.258C172.898 189.272 172.995 189.295 173.086 189.325C173.133 189.341 173.179 189.359 173.222 189.376C173.25 189.388 173.277 189.4 173.303 189.414L173.311 189.418C173.339 189.43 173.364 189.444 173.39 189.459L173.404 189.465C173.428 189.479 173.451 189.495 173.475 189.509C173.53 189.544 173.582 189.582 173.631 189.623L173.675 189.663L173.683 189.669L173.71 189.694L173.714 189.698L173.76 189.748C173.781 189.772 173.803 189.793 173.823 189.819C173.993 190.028 174.091 190.281 174.091 190.554Z",
    fill: "#FFB93E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.251 195.29H107.517C106.77 195.29 106.155 194.733 106.118 194.039C106.116 194.018 106.116 193.996 106.116 193.972V190.554C106.116 190.532 106.116 190.509 106.118 190.487C106.155 189.793 106.77 189.236 107.517 189.236H137.986C138 189.284 138.011 189.329 138.027 189.376C138.533 191.143 139.671 193.522 142.238 195.28L142.251 195.29Z",
    fill: "#FFA412"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.466 195.29H166.203V189.236H165.466V195.29Z",
    fill: "#FFA412"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.97 195.29H163.707V189.236H162.97V195.29Z",
    fill: "#FFA412"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.98 195.29H160.717V189.236H159.98V195.29Z",
    fill: "#FFA412"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.396 195.29H156.133V189.236H155.396V195.29Z",
    fill: "#FFA412"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.549 195.29H151.286V189.236H150.549V195.29Z",
    fill: "#FFA412"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.115 195.29H143.852V189.236H143.115V195.29Z",
    fill: "#FFA412"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.152 195.29H136.889V189.236H136.152V195.29Z",
    fill: "#FFA412"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.94 195.29H130.677V189.236H129.94V195.29Z",
    fill: "#FFA412"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.841 195.29H168.578V189.236H167.841V195.29Z",
    fill: "#FFA412"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.409 195.29H170.146V189.236H169.409V195.29Z",
    fill: "#FFA412"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.922 195.29H171.659V189.236H170.922V195.29Z",
    fill: "#FFA412"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.8 189.258V195.268C172.71 195.282 172.619 195.29 172.524 195.29H172.063V189.236H172.524C172.619 189.236 172.71 189.244 172.8 189.258Z",
    fill: "#FFA412"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.824 189.817V194.705C173.646 194.928 173.389 195.102 173.087 195.199V189.323C173.389 189.422 173.646 189.596 173.824 189.817Z",
    fill: "#FFA412"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.86 184.639V188.057C178.86 188.329 178.761 188.582 178.591 188.794C178.411 189.015 178.154 189.189 177.854 189.286C177.763 189.317 177.666 189.339 177.568 189.353C177.477 189.367 177.386 189.375 177.291 189.375H112.451C112.2 189.375 111.961 189.325 111.752 189.234C111.279 189.037 110.94 188.641 110.888 188.179C110.888 188.161 110.886 188.144 110.884 188.126C110.884 188.102 110.882 188.08 110.882 188.057V184.639C110.882 184.617 110.884 184.593 110.884 184.571C110.924 183.929 111.517 183.406 112.265 183.331C112.327 183.325 112.388 183.323 112.451 183.323H177.291C177.386 183.323 177.477 183.329 177.568 183.342C177.666 183.358 177.763 183.38 177.854 183.41C178.154 183.508 178.411 183.682 178.591 183.904C178.761 184.115 178.86 184.366 178.86 184.639Z",
    fill: "#FFB93E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.02 189.375H112.283C112.06 189.375 111.847 189.325 111.659 189.234C111.236 189.037 110.936 188.641 110.888 188.179C110.888 188.161 110.886 188.144 110.884 188.126C110.884 188.102 110.882 188.08 110.882 188.057V184.639C110.882 184.617 110.884 184.593 110.884 184.571C110.92 183.931 111.449 183.406 112.117 183.331C112.173 183.325 112.228 183.323 112.283 183.323H142.754L142.758 183.331C143.232 185.067 144.323 187.446 146.82 189.234C146.885 189.282 146.953 189.329 147.02 189.375Z",
    fill: "#FFA412"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.234 189.375H170.971V183.323H170.234V189.375Z",
    fill: "#FFA412"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.737 189.375H168.474V183.323H167.737V189.375Z",
    fill: "#FFA412"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.748 189.375H165.485V183.323H164.748V189.375Z",
    fill: "#FFA412"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.162 189.375H160.897V183.323H160.162V189.375Z",
    fill: "#FFA412"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.315 189.375H156.05V183.323H155.315V189.375Z",
    fill: "#FFA412"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.878 189.375H148.615V183.323H147.878V189.375Z",
    fill: "#FFA412"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.92 189.375H141.657V183.323H140.92V189.375Z",
    fill: "#FFA412"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.708 189.375H135.445V183.323H134.708V189.375Z",
    fill: "#FFA412"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.608 189.375H173.345V183.323H172.608V189.375Z",
    fill: "#FFA412"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.174 189.375H174.911V183.323H174.174V189.375Z",
    fill: "#FFA412"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.691 189.375H176.428V183.323H175.691V189.375Z",
    fill: "#FFA412"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.568 183.344V189.355C177.477 189.369 177.386 189.376 177.291 189.376H176.831V183.323H177.291C177.386 183.323 177.477 183.331 177.568 183.344Z",
    fill: "#FFA412"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.591 183.906V188.796C178.412 189.017 178.155 189.191 177.854 189.288V183.412C178.155 183.511 178.412 183.684 178.591 183.906Z",
    fill: "#FFA412"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.889 178.595V182.016C180.889 182.286 180.79 182.539 180.62 182.751C180.441 182.972 180.184 183.146 179.883 183.243C179.793 183.274 179.696 183.296 179.597 183.312C179.567 183.316 179.536 183.32 179.506 183.324L179.455 183.327L179.403 183.329C179.376 183.331 179.348 183.331 179.32 183.331H114.48C113.645 183.331 112.957 182.776 112.914 182.083C112.914 182.059 112.912 182.037 112.912 182.016V178.595C112.912 178.574 112.914 178.552 112.914 178.528C112.957 177.835 113.645 177.28 114.48 177.28H179.32C179.415 177.28 179.506 177.285 179.597 177.299C179.696 177.315 179.793 177.337 179.883 177.368C180.184 177.465 180.441 177.639 180.62 177.86C180.79 178.072 180.889 178.325 180.889 178.595Z",
    fill: "#FFB93E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.049 183.331H114.312C113.568 183.331 112.953 182.776 112.914 182.083C112.914 182.059 112.912 182.037 112.912 182.016V178.595C112.912 178.574 112.914 178.552 112.914 178.528C112.953 177.835 113.568 177.28 114.312 177.28H144.783C145.269 179.058 146.4 181.518 149.035 183.324L149.049 183.331Z",
    fill: "#FFA412"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.262 183.331H172.999V177.28H172.262V183.331Z",
    fill: "#FFA412"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.769 183.331H170.506V177.28H169.769V183.331Z",
    fill: "#FFA412"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.777 183.331H167.514V177.28H166.777V183.331Z",
    fill: "#FFA412"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.191 183.331H162.928V177.28H162.191V183.331Z",
    fill: "#FFA412"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.344 183.331H158.081V177.28H157.344V183.331Z",
    fill: "#FFA412"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.908 183.331H150.647V177.28H149.908V183.331Z",
    fill: "#FFA412"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.951 183.331H143.688V177.28H142.951V183.331Z",
    fill: "#FFA412"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.735 183.331H137.472V177.28H136.735V183.331Z",
    fill: "#FFA412"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.634 183.331H175.371V177.28H174.634V183.331Z",
    fill: "#FFA412"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.206 183.331H176.943V177.28H176.206V183.331Z",
    fill: "#FFA412"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.718 183.331H178.455V177.28H177.718V183.331Z",
    fill: "#FFA412"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.595 177.299V183.312C179.504 183.325 179.413 183.331 179.319 183.331H178.858V177.28H179.319C179.413 177.28 179.504 177.285 179.595 177.299Z",
    fill: "#FFA412"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.619 177.86V182.75C180.439 182.971 180.182 183.145 179.882 183.242V177.368C180.182 177.465 180.439 177.638 180.619 177.86Z",
    fill: "#FFA412"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.517 172.437V175.855C177.517 176.127 177.418 176.38 177.249 176.592C177.071 176.813 176.814 176.987 176.514 177.084C176.421 177.115 176.324 177.137 176.225 177.151C176.136 177.167 176.043 177.173 175.948 177.173H111.111C110.275 177.173 109.585 176.617 109.544 175.924C109.542 175.9 109.542 175.878 109.542 175.855V172.437C109.542 172.415 109.542 172.393 109.544 172.369C109.585 171.676 110.275 171.121 111.111 171.121H175.948C176.043 171.121 176.136 171.127 176.225 171.14C176.324 171.156 176.421 171.178 176.514 171.21C176.814 171.306 177.071 171.48 177.249 171.702C177.418 171.913 177.517 172.164 177.517 172.437Z",
    fill: "#FFB93E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.679 177.173H110.943C110.196 177.173 109.581 176.617 109.544 175.924C109.542 175.9 109.542 175.878 109.542 175.855V172.437C109.542 172.415 109.542 172.393 109.544 172.369C109.581 171.676 110.196 171.121 110.943 171.121H141.413C141.899 172.903 143.034 175.367 145.679 177.173Z",
    fill: "#FFA412"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.89 177.173H169.627V171.121H168.89V177.173Z",
    fill: "#FFA412"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.398 177.173H167.135V171.121H166.398V177.173Z",
    fill: "#FFA412"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.404 177.173H164.141V171.121H163.404V177.173Z",
    fill: "#FFA412"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.817 177.173H159.554V171.121H158.817V177.173Z",
    fill: "#FFA412"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.97 177.173H154.707V171.121H153.97V177.173Z",
    fill: "#FFA412"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.54 177.173H147.277V171.121H146.54V177.173Z",
    fill: "#FFA412"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.577 177.173H140.314V171.121H139.577V177.173Z",
    fill: "#FFA412"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.362 177.173H134.099V171.121H133.362V177.173Z",
    fill: "#FFA412"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 177.173H172.005V171.121H171.268V177.173Z",
    fill: "#FFA412"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.833 177.173H173.57V171.121H172.833V177.173Z",
    fill: "#FFA412"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.349 177.173H175.086V171.121H174.349V177.173Z",
    fill: "#FFA412"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.224 171.14V177.151C176.135 177.167 176.042 177.173 175.947 177.173H175.487V171.121H175.947C176.042 171.121 176.135 171.127 176.224 171.14Z",
    fill: "#FFA412"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.249 171.705V176.595C177.071 176.816 176.814 176.99 176.514 177.087V171.213C176.814 171.31 177.071 171.483 177.249 171.705Z",
    fill: "#FFA412"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.585 166.388V169.806C170.585 170.078 170.486 170.331 170.314 170.541C170.136 170.762 169.88 170.936 169.579 171.035C169.486 171.064 169.392 171.088 169.293 171.102C169.202 171.116 169.109 171.124 169.016 171.124H104.176C103.34 171.124 102.653 170.566 102.609 169.873C102.609 169.851 102.607 169.827 102.607 169.806V166.388C102.607 166.364 102.609 166.342 102.609 166.318C102.653 165.627 103.34 165.07 104.176 165.07H169.016C169.058 165.07 169.099 165.072 169.139 165.074L169.192 165.078C169.212 165.08 169.231 165.082 169.251 165.086L169.293 165.091C169.392 165.105 169.486 165.127 169.579 165.159L169.621 165.172L169.66 165.186C169.686 165.196 169.714 165.208 169.739 165.22L169.783 165.24L169.824 165.259C169.848 165.271 169.874 165.285 169.897 165.299C169.925 165.315 169.953 165.332 169.978 165.348C169.998 165.362 170.018 165.376 170.04 165.39L170.042 165.394L170.081 165.423C170.123 165.455 170.16 165.489 170.196 165.522L170.227 165.552L170.257 165.585C170.277 165.607 170.296 165.629 170.314 165.653C170.486 165.862 170.585 166.115 170.585 166.388Z",
    fill: "#FFB93E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.745 171.124H104.008C103.261 171.124 102.647 170.566 102.609 169.873C102.609 169.851 102.607 169.827 102.607 169.806V166.388C102.607 166.364 102.609 166.342 102.609 166.318C102.647 165.627 103.261 165.07 104.008 165.07H134.479C134.493 165.119 134.507 165.168 134.521 165.22C135.03 166.988 136.172 169.367 138.745 171.124Z",
    fill: "#FFA412"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.956 171.124H162.693V165.07H161.956V171.124Z",
    fill: "#FFA412"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.462 171.124H160.199V165.07H159.462V171.124Z",
    fill: "#FFA412"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.472 171.124H157.209V165.07H156.472V171.124Z",
    fill: "#FFA412"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.887 171.124H152.624V165.07H151.887V171.124Z",
    fill: "#FFA412"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.037 171.124H147.774V165.07H147.037V171.124Z",
    fill: "#FFA412"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.606 171.124H140.343V165.07H139.606V171.124Z",
    fill: "#FFA412"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.646 171.124H133.383V165.07H132.646V171.124Z",
    fill: "#FFA412"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.431 171.124H127.168V165.07H126.431V171.124Z",
    fill: "#FFA412"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.331 171.124H165.068V165.07H164.331V171.124Z",
    fill: "#FFA412"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.899 171.124H166.636V165.07H165.899V171.124Z",
    fill: "#FFA412"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.417 171.124H168.154V165.07H167.417V171.124Z",
    fill: "#FFA412"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.293 165.091V171.102C169.202 171.116 169.109 171.122 169.016 171.122H168.554V165.07H169.016C169.109 165.07 169.202 165.078 169.293 165.091Z",
    fill: "#FFA412"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.314 165.648V170.538C170.137 170.76 169.88 170.933 169.579 171.032V165.156C169.88 165.253 170.137 165.427 170.314 165.648Z",
    fill: "#FFA412"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.935 160.484V163.902C173.935 164.175 173.836 164.428 173.667 164.637C173.489 164.858 173.232 165.032 172.93 165.131C172.839 165.161 172.742 165.184 172.643 165.198C172.552 165.212 172.461 165.22 172.366 165.22H107.529C107.268 165.22 107.021 165.165 106.805 165.07C106.345 164.868 106.019 164.481 105.966 164.029C105.964 164.009 105.962 163.989 105.962 163.969C105.96 163.948 105.96 163.924 105.96 163.902V160.484C105.96 160.46 105.96 160.439 105.962 160.415C106.003 159.723 106.693 159.166 107.529 159.166H172.366C172.461 159.166 172.552 159.174 172.643 159.188C172.742 159.202 172.839 159.223 172.93 159.255C173.232 159.352 173.489 159.526 173.667 159.747C173.836 159.958 173.935 160.211 173.935 160.484Z",
    fill: "#FFB93E"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.095 165.22H107.361C107.127 165.22 106.908 165.165 106.714 165.07C106.304 164.868 106.011 164.481 105.966 164.029C105.964 164.009 105.962 163.989 105.962 163.969C105.96 163.948 105.96 163.924 105.96 163.902V160.484C105.96 160.46 105.96 160.439 105.962 160.415C105.999 159.723 106.614 159.166 107.361 159.166H137.829C138.304 160.899 139.39 163.278 141.884 165.07C141.953 165.119 142.024 165.169 142.095 165.22Z",
    fill: "#FFA412"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.309 165.22H166.046V159.166H165.309V165.22Z",
    fill: "#FFA412"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.812 165.22H163.548V159.166H162.812V165.22Z",
    fill: "#FFA412"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.821 165.22H160.558V159.166H159.821V165.22Z",
    fill: "#FFA412"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.239 165.22H155.975V159.166H155.239V165.22Z",
    fill: "#FFA412"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.388 165.22H151.125V159.166H150.388V165.22Z",
    fill: "#FFA412"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.955 165.22H143.692V159.166H142.955V165.22Z",
    fill: "#FFA412"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.996 165.22H136.733V159.166H135.996V165.22Z",
    fill: "#FFA412"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.782 165.22H130.519V159.166H129.782V165.22Z",
    fill: "#FFA412"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.684 165.22H168.421V159.166H167.684V165.22Z",
    fill: "#FFA412"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.253 165.22H169.99V159.166H169.253V165.22Z",
    fill: "#FFA412"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.767 165.22H171.504V159.166H170.767V165.22Z",
    fill: "#FFA412"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.641 159.188V165.198C172.552 165.212 172.459 165.218 172.365 165.218H171.904V159.166H172.365C172.459 159.166 172.552 159.174 172.641 159.188Z",
    fill: "#FFA412"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.663 159.747V164.637C173.486 164.859 173.229 165.033 172.927 165.129V159.255C173.229 159.352 173.486 159.526 173.663 159.747Z",
    fill: "#FFA412"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.487 154.431V157.849C175.487 158.122 175.388 158.374 175.218 158.584C175.04 158.805 174.784 158.981 174.481 159.078C174.39 159.108 174.294 159.131 174.195 159.145C174.106 159.159 174.013 159.167 173.918 159.167H109.08C108.244 159.167 107.555 158.61 107.513 157.916C107.511 157.894 107.511 157.873 107.511 157.849V154.431C107.511 154.409 107.511 154.385 107.513 154.364C107.551 153.721 108.144 153.198 108.895 153.123C108.956 153.117 109.017 153.113 109.08 153.113H173.918C174.013 153.113 174.106 153.121 174.195 153.135C174.294 153.148 174.39 153.172 174.481 153.202C174.784 153.301 175.04 153.474 175.218 153.696C175.388 153.905 175.487 154.158 175.487 154.431Z",
    fill: "#FFB93E"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.649 159.167H108.912C108.165 159.167 107.551 158.61 107.513 157.916C107.511 157.894 107.511 157.873 107.511 157.849V154.431C107.511 154.409 107.511 154.385 107.513 154.364C107.547 153.721 108.077 153.198 108.746 153.123C108.8 153.117 108.855 153.113 108.912 153.113H139.383L139.385 153.123C139.873 154.903 141.007 157.363 143.649 159.167Z",
    fill: "#FFA412"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.859 159.167H167.596V153.113H166.859V159.167Z",
    fill: "#FFA412"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.367 159.167H165.102V153.113H164.367V159.167Z",
    fill: "#FFA412"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.375 159.167H162.112V153.113H161.375V159.167Z",
    fill: "#FFA412"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.79 159.167H157.527V153.113H156.79V159.167Z",
    fill: "#FFA412"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.94 159.167H152.677V153.113H151.94V159.167Z",
    fill: "#FFA412"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.509 159.167H145.246V153.113H144.509V159.167Z",
    fill: "#FFA412"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.545 159.167H138.282V153.113H137.545V159.167Z",
    fill: "#FFA412"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.335 159.167H132.072V153.113H131.335V159.167Z",
    fill: "#FFA412"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.236 159.167H169.973V153.113H169.236V159.167Z",
    fill: "#FFA412"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.804 159.167H171.541V153.113H170.804V159.167Z",
    fill: "#FFA412"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.318 159.167H173.055V153.113H172.318V159.167Z",
    fill: "#FFA412"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.193 153.135V159.145C174.104 159.159 174.011 159.167 173.916 159.167H173.456V153.113H173.916C174.011 153.113 174.104 153.121 174.193 153.135Z",
    fill: "#FFA412"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.218 153.693V158.581C175.041 158.803 174.784 158.977 174.481 159.075V153.199C174.784 153.298 175.041 153.472 175.218 153.693Z",
    fill: "#FFA412"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.72 148.386V151.804C170.72 152.076 170.622 152.329 170.452 152.541C170.274 152.762 170.017 152.936 169.717 153.033C169.624 153.064 169.529 153.086 169.428 153.1C169.399 153.106 169.369 153.11 169.337 153.112L169.286 153.118L169.237 153.12C169.209 153.122 169.181 153.122 169.154 153.122H104.314C103.478 153.122 102.788 152.564 102.747 151.873C102.747 151.849 102.745 151.827 102.745 151.804V148.386C102.745 148.364 102.747 148.34 102.747 148.318C102.747 148.299 102.749 148.281 102.751 148.263C102.814 147.706 103.296 147.246 103.926 147.109L103.974 147.099C104.084 147.08 104.197 147.07 104.314 147.07H169.154C169.201 147.07 169.246 147.072 169.294 147.074C169.314 147.076 169.335 147.078 169.355 147.08H169.357C169.381 147.082 169.405 147.086 169.428 147.089C169.529 147.105 169.624 147.127 169.717 147.157C170.017 147.255 170.274 147.429 170.452 147.651C170.622 147.862 170.72 148.113 170.72 148.386Z",
    fill: "#FFB93E"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.882 153.122H104.146C103.399 153.122 102.784 152.564 102.747 151.873C102.747 151.849 102.745 151.827 102.745 151.804V148.386C102.745 148.364 102.747 148.34 102.747 148.318C102.747 148.299 102.749 148.281 102.751 148.263C102.808 147.692 103.257 147.226 103.837 147.101C103.857 147.097 103.877 147.093 103.897 147.089C103.978 147.076 104.061 147.07 104.146 147.07H134.617L134.628 147.111C135.12 148.887 136.254 151.322 138.868 153.112L138.882 153.122Z",
    fill: "#FFA412"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.093 153.121H162.83V147.068H162.093V153.121Z",
    fill: "#FFA412"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.599 153.121H160.336V147.068H159.599V153.121Z",
    fill: "#FFA412"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.608 153.121H157.345V147.068H156.608V153.121Z",
    fill: "#FFA412"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.021 153.121H152.758V147.068H152.021V153.121Z",
    fill: "#FFA412"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.174 153.121H147.911V147.068H147.174V153.121Z",
    fill: "#FFA412"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.741 153.121H140.478V147.068H139.741V153.121Z",
    fill: "#FFA412"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.783 153.121H133.52V147.068H132.783V153.121Z",
    fill: "#FFA412"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.565 153.121H127.302V147.068H126.565V153.121Z",
    fill: "#FFA412"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.469 153.121H165.206V147.068H164.469V153.121Z",
    fill: "#FFA412"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.038 153.121H166.775V147.068H166.038V153.121Z",
    fill: "#FFA412"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.554 153.121H168.291V147.068H167.554V153.121Z",
    fill: "#FFA412"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.427 147.089V153.1C169.336 153.114 169.243 153.121 169.151 153.121H168.688V147.068H169.151C169.243 147.068 169.336 147.076 169.427 147.089Z",
    fill: "#FFA412"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.45 147.649V152.537C170.272 152.761 170.015 152.934 169.715 153.031V147.155C170.015 147.254 170.272 147.428 170.45 147.649Z",
    fill: "#FFA412"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.585 142.375V145.795C170.585 146.066 170.486 146.319 170.314 146.53C170.136 146.752 169.88 146.926 169.579 147.022C169.506 147.046 169.431 147.066 169.356 147.08H169.354C169.332 147.084 169.312 147.088 169.293 147.092C169.202 147.105 169.109 147.111 169.016 147.111H104.176C104.107 147.111 104.04 147.107 103.973 147.099C103.947 147.098 103.921 147.094 103.896 147.09C103.192 146.983 102.647 146.475 102.609 145.863C102.609 145.839 102.607 145.817 102.607 145.795V142.375C102.607 142.354 102.609 142.332 102.609 142.308C102.653 141.615 103.34 141.059 104.176 141.059H169.016C169.058 141.059 169.099 141.059 169.139 141.063L169.192 141.067C169.212 141.069 169.231 141.071 169.251 141.073L169.293 141.079C169.392 141.095 169.486 141.117 169.579 141.148L169.621 141.162L169.66 141.176C169.686 141.186 169.714 141.198 169.739 141.208C169.767 141.221 169.797 141.235 169.824 141.249C169.848 141.261 169.874 141.275 169.897 141.289C169.925 141.304 169.953 141.32 169.978 141.338C169.998 141.352 170.018 141.366 170.04 141.38L170.042 141.383L170.081 141.413C170.123 141.443 170.16 141.476 170.196 141.512L170.227 141.542L170.257 141.573C170.277 141.595 170.296 141.619 170.314 141.64C170.486 141.852 170.585 142.105 170.585 142.375Z",
    fill: "#FFB93E"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.745 147.111H104.008C103.981 147.111 103.953 147.111 103.925 147.109C103.896 147.107 103.866 147.105 103.836 147.101C103.169 147.024 102.645 146.501 102.609 145.863C102.609 145.839 102.607 145.817 102.607 145.795V142.375C102.607 142.354 102.609 142.332 102.609 142.308C102.647 141.615 103.261 141.059 104.008 141.059H134.479C134.493 141.109 134.507 141.158 134.521 141.208C135.024 142.962 136.155 145.315 138.682 147.07C138.703 147.084 138.723 147.098 138.745 147.111Z",
    fill: "#FFA412"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.956 147.111H162.693V141.059H161.956V147.111Z",
    fill: "#FFA412"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.462 147.111H160.199V141.059H159.462V147.111Z",
    fill: "#FFA412"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.472 147.111H157.209V141.059H156.472V147.111Z",
    fill: "#FFA412"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.887 147.111H152.624V141.059H151.887V147.111Z",
    fill: "#FFA412"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.037 147.111H147.774V141.059H147.037V147.111Z",
    fill: "#FFA412"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.606 147.111H140.343V141.059H139.606V147.111Z",
    fill: "#FFA412"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.646 147.111H133.383V141.059H132.646V147.111Z",
    fill: "#FFA412"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.431 147.111H127.168V141.059H126.431V147.111Z",
    fill: "#FFA412"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.331 147.111H165.068V141.059H164.331V147.111Z",
    fill: "#FFA412"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.899 147.111H166.636V141.059H165.899V147.111Z",
    fill: "#FFA412"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.417 147.111H168.154V141.059H167.417V147.111Z",
    fill: "#FFA412"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.293 141.079V147.092C169.202 147.105 169.109 147.111 169.016 147.111H168.554V141.059H169.016C169.109 141.059 169.202 141.065 169.293 141.079Z",
    fill: "#FFA412"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.314 141.64V146.53C170.137 146.751 169.88 146.925 169.579 147.022V141.148C169.88 141.244 170.137 141.418 170.314 141.64Z",
    fill: "#FFA412"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.935 136.472V139.89C173.935 140.163 173.836 140.415 173.667 140.627C173.489 140.848 173.232 141.022 172.93 141.119C172.839 141.15 172.742 141.172 172.643 141.186C172.552 141.202 172.461 141.208 172.366 141.208H107.529C107.268 141.208 107.021 141.154 106.805 141.06C106.345 140.858 106.019 140.469 105.966 140.018C105.964 139.999 105.962 139.979 105.962 139.959C105.96 139.935 105.96 139.914 105.96 139.89V136.472C105.96 136.45 105.96 136.428 105.962 136.405C106.003 135.711 106.693 135.156 107.529 135.156H172.366C172.461 135.156 172.552 135.162 172.643 135.176C172.742 135.191 172.839 135.213 172.93 135.245C173.232 135.342 173.489 135.515 173.667 135.737C173.836 135.948 173.935 136.199 173.935 136.472Z",
    fill: "#FFB93E"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.095 141.208H107.361C107.127 141.208 106.908 141.154 106.714 141.06C106.304 140.858 106.011 140.469 105.966 140.018C105.964 139.999 105.962 139.979 105.962 139.959C105.96 139.935 105.96 139.914 105.96 139.89V136.472C105.96 136.45 105.96 136.428 105.962 136.405C105.999 135.711 106.614 135.156 107.361 135.156H137.829C138.304 136.889 139.39 139.268 141.884 141.06C141.953 141.109 142.024 141.158 142.095 141.208Z",
    fill: "#FFA412"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.309 141.208H166.046V135.156H165.309V141.208Z",
    fill: "#FFA412"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.812 141.208H163.548V135.156H162.812V141.208Z",
    fill: "#FFA412"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.821 141.208H160.558V135.156H159.821V141.208Z",
    fill: "#FFA412"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.239 141.208H155.975V135.156H155.239V141.208Z",
    fill: "#FFA412"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.388 141.208H151.125V135.156H150.388V141.208Z",
    fill: "#FFA412"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.955 141.208H143.692V135.156H142.955V141.208Z",
    fill: "#FFA412"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.996 141.208H136.733V135.156H135.996V141.208Z",
    fill: "#FFA412"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.782 141.208H130.519V135.156H129.782V141.208Z",
    fill: "#FFA412"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.684 141.208H168.421V135.156H167.684V141.208Z",
    fill: "#FFA412"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.253 141.208H169.99V135.156H169.253V141.208Z",
    fill: "#FFA412"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.767 141.208H171.504V135.156H170.767V141.208Z",
    fill: "#FFA412"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.641 135.176V141.188C172.552 141.202 172.459 141.208 172.365 141.208H171.904V135.156H172.365C172.459 135.156 172.552 135.162 172.641 135.176Z",
    fill: "#FFA412"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.663 135.737V140.627C173.486 140.848 173.229 141.022 172.927 141.119V135.245C173.229 135.342 173.486 135.516 173.663 135.737Z",
    fill: "#FFA412"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.233 130.418V133.836C179.233 134.109 179.134 134.362 178.964 134.571C178.785 134.793 178.528 134.967 178.227 135.065C178.137 135.095 178.04 135.117 177.941 135.133C177.85 135.146 177.759 135.154 177.664 135.154H112.824C111.989 135.154 111.301 134.597 111.258 133.904C111.258 133.882 111.256 133.858 111.256 133.836V130.418C111.256 130.395 111.258 130.373 111.258 130.351C111.297 129.709 111.89 129.185 112.641 129.11C112.7 129.102 112.763 129.1 112.824 129.1H177.664C177.759 129.1 177.85 129.108 177.941 129.122C178.04 129.136 178.137 129.158 178.227 129.189C178.528 129.286 178.785 129.46 178.964 129.683C179.134 129.893 179.233 130.146 179.233 130.418Z",
    fill: "#FFB93E"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.393 135.154H112.656C111.912 135.154 111.297 134.597 111.258 133.904C111.258 133.882 111.256 133.858 111.256 133.836V130.418C111.256 130.395 111.258 130.373 111.258 130.351C111.293 129.709 111.823 129.185 112.49 129.11C112.546 129.102 112.601 129.1 112.656 129.1H143.127L143.131 129.11C143.619 130.891 144.753 133.35 147.393 135.154Z",
    fill: "#FFA412"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.608 135.154H171.345V129.1H170.608V135.154Z",
    fill: "#FFA412"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.112 135.154H168.849V129.1H168.112V135.154Z",
    fill: "#FFA412"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.121 135.154H165.858V129.1H165.121V135.154Z",
    fill: "#FFA412"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.536 135.154H161.273V129.1H160.536V135.154Z",
    fill: "#FFA412"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.688 135.154H156.425V129.1H155.688V135.154Z",
    fill: "#FFA412"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.254 135.154H148.991V129.1H148.254V135.154Z",
    fill: "#FFA412"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.295 135.154H142.032V129.1H141.295V135.154Z",
    fill: "#FFA412"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.082 135.154H135.819V129.1H135.082V135.154Z",
    fill: "#FFA412"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.98 135.154H173.717V129.1H172.98V135.154Z",
    fill: "#FFA412"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.551 135.154H175.286V129.1H174.551V135.154Z",
    fill: "#FFA412"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.064 135.154H176.801V129.1H176.064V135.154Z",
    fill: "#FFA412"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.942 129.122V135.133C177.851 135.146 177.76 135.154 177.665 135.154H177.205V129.1H177.665C177.76 129.1 177.851 129.108 177.942 129.122Z",
    fill: "#FFA412"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.966 129.683V134.573C178.787 134.795 178.532 134.969 178.229 135.067V129.191C178.532 129.288 178.787 129.462 178.966 129.683Z",
    fill: "#FFA412"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.265 238.434V241.852C272.265 242.123 272.167 242.376 271.997 242.587C271.819 242.809 271.562 242.983 271.26 243.079C271.169 243.111 271.072 243.133 270.973 243.149C270.882 243.162 270.791 243.168 270.697 243.168H205.858C205.022 243.168 204.333 242.613 204.291 241.92C204.29 241.898 204.289 241.874 204.289 241.852V238.434C204.289 238.411 204.29 238.389 204.291 238.365C204.333 237.672 205.022 237.116 205.858 237.116H270.697C270.791 237.116 270.882 237.124 270.973 237.136C271.072 237.152 271.169 237.174 271.26 237.205C271.562 237.302 271.819 237.476 271.997 237.697C272.167 237.909 272.265 238.162 272.265 238.434Z",
    fill: "#FFB93E"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.425 243.168H205.69C204.944 243.168 204.329 242.613 204.291 241.92C204.29 241.898 204.289 241.874 204.289 241.852V238.434C204.289 238.411 204.29 238.389 204.291 238.365C204.329 237.672 204.944 237.116 205.69 237.116H236.16C236.648 238.899 237.782 241.362 240.425 243.168Z",
    fill: "#FFA412"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.639 243.168H264.376V237.116H263.639V243.168Z",
    fill: "#FFA412"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.145 243.168H261.882V237.116H261.145V243.168Z",
    fill: "#FFA412"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.15 243.168H258.887V237.116H258.15V243.168Z",
    fill: "#FFA412"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.567 243.168H254.304V237.116H253.567V243.168Z",
    fill: "#FFA412"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.72 243.168H249.457V237.116H248.72V243.168Z",
    fill: "#FFA412"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.286 243.168H242.023V237.116H241.286V243.168Z",
    fill: "#FFA412"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.327 243.168H235.064V237.116H234.327V243.168Z",
    fill: "#FFA412"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.111 243.168H228.848V237.116H228.111V243.168Z",
    fill: "#FFA412"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.014 243.168H266.751V237.116H266.014V243.168Z",
    fill: "#FFA412"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.583 243.168H268.32V237.116H267.583V243.168Z",
    fill: "#FFA412"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.099 243.168H269.836V237.116H269.099V243.168Z",
    fill: "#FFA412"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.974 237.136V243.149C270.883 243.162 270.792 243.168 270.697 243.168H270.237V237.116H270.697C270.792 237.116 270.883 237.124 270.974 237.136Z",
    fill: "#FFA412"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.998 237.7V242.591C271.82 242.812 271.563 242.986 271.261 243.083V237.208C271.563 237.305 271.82 237.479 271.998 237.7Z",
    fill: "#FFA412"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.333 232.382V235.8C265.333 236.073 265.234 236.325 265.064 236.535C264.886 236.756 264.629 236.93 264.329 237.029C264.236 237.058 264.139 237.082 264.04 237.096C263.952 237.11 263.859 237.118 263.764 237.118H198.926C198.09 237.118 197.401 236.561 197.359 235.867C197.358 235.845 197.357 235.822 197.357 235.8V232.382C197.357 232.36 197.358 232.336 197.359 232.315C197.401 231.621 198.09 231.064 198.926 231.064H263.764C263.805 231.064 263.847 231.066 263.888 231.068L263.942 231.074C263.961 231.074 263.981 231.076 263.999 231.08L264.04 231.086C264.139 231.099 264.236 231.123 264.329 231.153L264.368 231.167L264.408 231.182C264.436 231.192 264.461 231.202 264.487 231.214L264.532 231.234L264.572 231.254C264.598 231.267 264.621 231.279 264.647 231.293C264.675 231.309 264.7 231.327 264.728 231.344C264.748 231.356 264.768 231.37 264.787 231.386L264.791 231.388L264.831 231.418C264.87 231.449 264.91 231.483 264.945 231.516L264.977 231.548L265.007 231.58C265.026 231.601 265.046 231.623 265.064 231.647C265.234 231.856 265.333 232.109 265.333 232.382Z",
    fill: "#FFB93E"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.495 237.118H198.758C198.011 237.118 197.397 236.561 197.359 235.867C197.358 235.845 197.357 235.822 197.357 235.8V232.382C197.357 232.36 197.358 232.336 197.359 232.315C197.397 231.621 198.011 231.064 198.758 231.064H229.227C229.241 231.113 229.254 231.163 229.27 231.214C229.778 232.982 230.922 235.361 233.495 237.118Z",
    fill: "#FFA412"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.705 237.118H257.442V231.064H256.705V237.118Z",
    fill: "#FFA412"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.211 237.118H254.948V231.064H254.211V237.118Z",
    fill: "#FFA412"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.221 237.118H251.958V231.064H251.221V237.118Z",
    fill: "#FFA412"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.637 237.118H247.374V231.064H246.637V237.118Z",
    fill: "#FFA412"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.786 237.118H242.523V231.064H241.786V237.118Z",
    fill: "#FFA412"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.353 237.118H235.09V231.064H234.353V237.118Z",
    fill: "#FFA412"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.394 237.118H228.129V231.064H227.394V237.118Z",
    fill: "#FFA412"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.18 237.118H221.917V231.064H221.18V237.118Z",
    fill: "#FFA412"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.082 237.118H259.819V231.064H259.082V237.118Z",
    fill: "#FFA412"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.649 237.118H261.386V231.064H260.649V237.118Z",
    fill: "#FFA412"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.164 237.118H262.901V231.064H262.164V237.118Z",
    fill: "#FFA412"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.04 231.086V237.096C263.952 237.11 263.859 237.118 263.764 237.118H263.303V231.064H263.764C263.859 231.064 263.952 231.072 264.04 231.086Z",
    fill: "#FFA412"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.064 231.646V236.534C264.886 236.756 264.629 236.929 264.329 237.028V231.152C264.629 231.249 264.886 231.425 265.064 231.646Z",
    fill: "#FFA412"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.683 226.479V229.897C268.683 230.17 268.584 230.423 268.414 230.632C268.234 230.854 267.977 231.028 267.677 231.126C267.586 231.156 267.489 231.18 267.391 231.194C267.3 231.207 267.209 231.215 267.114 231.215H202.275C202.015 231.215 201.768 231.16 201.552 231.065C201.093 230.864 200.765 230.476 200.713 230.024C200.71 230.004 200.709 229.984 200.708 229.965C200.707 229.943 200.706 229.919 200.706 229.897V226.479C200.706 226.456 200.707 226.434 200.708 226.412C200.75 225.719 201.439 225.161 202.275 225.161H267.114C267.209 225.161 267.3 225.169 267.391 225.183C267.489 225.197 267.586 225.221 267.677 225.25C267.977 225.347 268.234 225.523 268.414 225.744C268.584 225.954 268.683 226.207 268.683 226.479Z",
    fill: "#FFB93E"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.843 231.215H202.107C201.874 231.215 201.655 231.16 201.462 231.065C201.051 230.864 200.759 230.476 200.713 230.024C200.71 230.004 200.709 229.984 200.708 229.965C200.707 229.943 200.706 229.919 200.706 229.897V226.479C200.706 226.456 200.707 226.434 200.708 226.412C200.746 225.719 201.361 225.161 202.107 225.161H232.577C233.051 226.894 234.136 229.275 236.629 231.065C236.7 231.116 236.772 231.166 236.843 231.215Z",
    fill: "#FFA412"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.059 231.215H260.796V225.161H260.059V231.215Z",
    fill: "#FFA412"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.561 231.215H258.298V225.161H257.561V231.215Z",
    fill: "#FFA412"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.571 231.215H255.308V225.161H254.571V231.215Z",
    fill: "#FFA412"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.988 231.215H250.725V225.161H249.988V231.215Z",
    fill: "#FFA412"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.138 231.215H245.875V225.161H245.138V231.215Z",
    fill: "#FFA412"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.702 231.215H238.437V225.161H237.702V231.215Z",
    fill: "#FFA412"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.745 231.215H231.482V225.161H230.745V231.215Z",
    fill: "#FFA412"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.531 231.215H225.268V225.161H224.531V231.215Z",
    fill: "#FFA412"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.433 231.215H263.168V225.161H262.433V231.215Z",
    fill: "#FFA412"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.999 231.215H264.736V225.161H263.999V231.215Z",
    fill: "#FFA412"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.516 231.215H266.253V225.161H265.516V231.215Z",
    fill: "#FFA412"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.391 225.183V231.194C267.3 231.207 267.209 231.215 267.114 231.215H266.654V225.161H267.114C267.209 225.161 267.3 225.169 267.391 225.183Z",
    fill: "#FFA412"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.413 225.745V230.633C268.233 230.854 267.976 231.028 267.676 231.127V225.251C267.976 225.348 268.233 225.522 268.413 225.745Z",
    fill: "#FFA412"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.237 220.424V223.842C270.237 224.115 270.139 224.368 269.969 224.579C269.789 224.8 269.534 224.974 269.232 225.071C269.141 225.103 269.044 225.124 268.945 225.138C268.854 225.152 268.763 225.16 268.669 225.16H203.83C202.994 225.16 202.305 224.605 202.263 223.911C202.262 223.887 202.261 223.866 202.261 223.842V220.424C202.261 220.402 202.262 220.378 202.263 220.357C202.302 219.715 202.894 219.191 203.644 219.116C203.705 219.11 203.766 219.106 203.83 219.106H268.669C268.763 219.106 268.854 219.114 268.945 219.128C269.044 219.143 269.141 219.165 269.232 219.197C269.534 219.294 269.789 219.468 269.969 219.689C270.139 219.9 270.237 220.151 270.237 220.424Z",
    fill: "#FFB93E"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.397 225.16H203.661C202.916 225.16 202.301 224.605 202.263 223.911C202.262 223.887 202.261 223.866 202.261 223.842V220.424C202.261 220.402 202.262 220.378 202.263 220.357C202.297 219.716 202.826 219.191 203.496 219.116C203.55 219.11 203.605 219.106 203.661 219.106H234.131L234.135 219.116C234.623 220.896 235.758 223.356 238.397 225.16Z",
    fill: "#FFA412"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.608 225.16H262.345V219.106H261.608V225.16Z",
    fill: "#FFA412"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.114 225.16H259.851V219.106H259.114V225.16Z",
    fill: "#FFA412"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.124 225.16H256.861V219.106H256.124V225.16Z",
    fill: "#FFA412"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.54 225.16H252.277V219.106H251.54V225.16Z",
    fill: "#FFA412"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.689 225.16H247.426V219.106H246.689V225.16Z",
    fill: "#FFA412"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.258 225.16H239.995V219.106H239.258V225.16Z",
    fill: "#FFA412"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.296 225.16H233.033V219.106H232.296V225.16Z",
    fill: "#FFA412"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.084 225.16H226.821V219.106H226.084V225.16Z",
    fill: "#FFA412"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.986 225.16H264.723V219.106H263.986V225.16Z",
    fill: "#FFA412"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.552 225.16H266.287V219.106H265.552V225.16Z",
    fill: "#FFA412"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.067 225.16H267.804V219.106H267.067V225.16Z",
    fill: "#FFA412"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.942 219.128V225.138C268.851 225.152 268.761 225.16 268.666 225.16H268.205V219.106H268.666C268.761 219.106 268.851 219.114 268.942 219.128Z",
    fill: "#FFA412"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.968 219.689V224.579C269.788 224.8 269.533 224.974 269.231 225.071V219.195C269.533 219.294 269.788 219.468 269.968 219.689Z",
    fill: "#FFA412"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.469 214.381V217.802C265.469 218.072 265.37 218.325 265.2 218.537C265.023 218.758 264.766 218.932 264.465 219.029C264.373 219.06 264.276 219.082 264.177 219.098C264.147 219.102 264.118 219.106 264.086 219.108L264.035 219.113L263.983 219.115C263.956 219.117 263.928 219.117 263.9 219.117H199.062C198.226 219.117 197.537 218.562 197.495 217.869C197.494 217.845 197.493 217.823 197.493 217.802V214.381C197.493 214.36 197.494 214.338 197.495 214.314C197.496 214.296 197.498 214.277 197.499 214.259C197.562 213.702 198.044 213.241 198.675 213.105L198.723 213.097C198.832 213.075 198.946 213.066 199.062 213.066H263.9C263.948 213.066 263.995 213.068 264.041 213.07C264.062 213.071 264.082 213.073 264.104 213.075C264.13 213.079 264.153 213.083 264.177 213.085C264.276 213.101 264.373 213.123 264.465 213.154C264.766 213.251 265.023 213.425 265.2 213.646C265.37 213.858 265.469 214.111 265.469 214.381Z",
    fill: "#FFB93E"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.631 219.117H198.894C198.148 219.117 197.533 218.562 197.495 217.869C197.494 217.845 197.493 217.823 197.493 217.802V214.381C197.493 214.36 197.494 214.338 197.495 214.314C197.496 214.296 197.498 214.277 197.499 214.259C197.556 213.69 198.004 213.222 198.586 213.097C198.606 213.093 198.626 213.089 198.646 213.085C198.727 213.071 198.809 213.066 198.894 213.066H229.365L229.377 213.107C229.869 214.883 231.003 217.317 233.617 219.108L233.631 219.117Z",
    fill: "#FFA412"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.84 219.117H257.577V213.066H256.84V219.117Z",
    fill: "#FFA412"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.348 219.117H255.085V213.066H254.348V219.117Z",
    fill: "#FFA412"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.358 219.117H252.095V213.066H251.358V219.117Z",
    fill: "#FFA412"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.771 219.117H247.508V213.066H246.771V219.117Z",
    fill: "#FFA412"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.924 219.117H242.661V213.066H241.924V219.117Z",
    fill: "#FFA412"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.49 219.117H235.226V213.066H234.49V219.117Z",
    fill: "#FFA412"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.528 219.117H228.265V213.066H227.528V219.117Z",
    fill: "#FFA412"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.314 219.117H222.051V213.066H221.314V219.117Z",
    fill: "#FFA412"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.218 219.117H259.955V213.066H259.218V219.117Z",
    fill: "#FFA412"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.787 219.117H261.524V213.066H260.787V219.117Z",
    fill: "#FFA412"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.301 219.117H263.038V213.066H262.301V219.117Z",
    fill: "#FFA412"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.176 213.085V219.098C264.087 219.112 263.994 219.117 263.899 219.117H263.439V213.066H263.899C263.994 213.066 264.087 213.071 264.176 213.085Z",
    fill: "#FFA412"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.199 213.646V218.536C265.022 218.758 264.765 218.932 264.464 219.028V213.154C264.765 213.251 265.022 213.425 265.199 213.646Z",
    fill: "#FFA412"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.333 208.371V211.79C265.333 212.062 265.234 212.313 265.064 212.525C264.886 212.746 264.629 212.92 264.329 213.017C264.256 213.042 264.181 213.06 264.104 213.074C264.082 213.078 264.062 213.082 264.04 213.086C263.952 213.1 263.859 213.105 263.764 213.105H198.926C198.857 213.105 198.789 213.103 198.723 213.096C198.697 213.092 198.671 213.09 198.646 213.084C197.941 212.977 197.396 212.471 197.359 211.857C197.358 211.835 197.357 211.811 197.357 211.79V208.371C197.357 208.348 197.358 208.326 197.359 208.302C197.401 207.609 198.09 207.054 198.926 207.054H263.764C263.805 207.054 263.847 207.056 263.888 207.058L263.942 207.061C263.961 207.063 263.981 207.065 263.999 207.069L264.04 207.075C264.139 207.089 264.236 207.111 264.329 207.143L264.368 207.156L264.408 207.17C264.436 207.18 264.461 207.192 264.487 207.202C264.517 207.216 264.544 207.229 264.572 207.243C264.598 207.255 264.621 207.269 264.647 207.283C264.675 207.299 264.7 207.316 264.728 207.332C264.748 207.346 264.768 207.36 264.787 207.374L264.791 207.378L264.831 207.407C264.87 207.437 264.91 207.47 264.945 207.506L264.977 207.536L265.007 207.567C265.026 207.589 265.046 207.613 265.064 207.634C265.234 207.846 265.333 208.099 265.333 208.371Z",
    fill: "#FFB93E"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.495 213.105H198.758C198.73 213.105 198.702 213.105 198.675 213.103C198.645 213.103 198.615 213.1 198.586 213.096C197.918 213.019 197.393 212.497 197.359 211.857C197.358 211.835 197.357 211.811 197.357 211.79V208.371C197.357 208.348 197.358 208.326 197.359 208.302C197.397 207.609 198.011 207.054 198.758 207.054H229.227C229.241 207.103 229.254 207.152 229.27 207.202C229.774 208.956 230.902 211.311 233.431 213.064C233.453 213.078 233.473 213.092 233.495 213.105Z",
    fill: "#FFA412"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.705 213.107H257.442V207.054H256.705V213.107Z",
    fill: "#FFA412"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.211 213.107H254.948V207.054H254.211V213.107Z",
    fill: "#FFA412"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.221 213.107H251.958V207.054H251.221V213.107Z",
    fill: "#FFA412"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.637 213.107H247.374V207.054H246.637V213.107Z",
    fill: "#FFA412"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.786 213.107H242.523V207.054H241.786V213.107Z",
    fill: "#FFA412"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.353 213.107H235.09V207.054H234.353V213.107Z",
    fill: "#FFA412"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.394 213.107H228.129V207.054H227.394V213.107Z",
    fill: "#FFA412"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.18 213.107H221.917V207.054H221.18V213.107Z",
    fill: "#FFA412"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.082 213.107H259.819V207.054H259.082V213.107Z",
    fill: "#FFA412"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.649 213.107H261.386V207.054H260.649V213.107Z",
    fill: "#FFA412"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.164 213.107H262.901V207.054H262.164V213.107Z",
    fill: "#FFA412"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.04 207.075V213.086C263.952 213.1 263.859 213.105 263.764 213.105H263.303V207.054H263.764C263.859 207.054 263.952 207.061 264.04 207.075Z",
    fill: "#FFA412"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.064 207.634V212.524C264.886 212.745 264.629 212.919 264.329 213.018V207.142C264.629 207.239 264.886 207.413 265.064 207.634Z",
    fill: "#FFA412"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.683 202.468V205.886C268.683 206.157 268.584 206.41 268.414 206.621C268.234 206.842 267.977 207.016 267.677 207.113C267.586 207.145 267.489 207.166 267.391 207.182C267.3 207.196 267.209 207.202 267.114 207.202H202.275C202.015 207.202 201.768 207.149 201.552 207.054C201.093 206.852 200.765 206.465 200.713 206.012C200.71 205.993 200.709 205.973 200.708 205.953C200.707 205.929 200.706 205.908 200.706 205.886V202.468C200.706 202.444 200.707 202.422 200.708 202.399C200.75 201.705 201.439 201.15 202.275 201.15H267.114C267.209 201.15 267.3 201.156 267.391 201.17C267.489 201.186 267.586 201.207 267.677 201.239C267.977 201.336 268.234 201.51 268.414 201.731C268.584 201.942 268.683 202.195 268.683 202.468Z",
    fill: "#FFB93E"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.843 207.202H202.107C201.874 207.202 201.655 207.149 201.462 207.054C201.051 206.852 200.759 206.465 200.713 206.012C200.71 205.993 200.709 205.973 200.708 205.953C200.707 205.929 200.706 205.908 200.706 205.886V202.468C200.706 202.444 200.707 202.422 200.708 202.399C200.746 201.705 201.361 201.15 202.107 201.15H232.577C233.051 202.883 234.136 205.262 236.629 207.054C236.7 207.103 236.772 207.153 236.843 207.202Z",
    fill: "#FFA412"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.059 207.204H260.796V201.15H260.059V207.204Z",
    fill: "#FFA412"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.561 207.204H258.298V201.15H257.561V207.204Z",
    fill: "#FFA412"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.571 207.204H255.308V201.15H254.571V207.204Z",
    fill: "#FFA412"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.988 207.204H250.725V201.15H249.988V207.204Z",
    fill: "#FFA412"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.138 207.204H245.875V201.15H245.138V207.204Z",
    fill: "#FFA412"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.702 207.204H238.437V201.15H237.702V207.204Z",
    fill: "#FFA412"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.745 207.204H231.482V201.15H230.745V207.204Z",
    fill: "#FFA412"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.531 207.204H225.268V201.15H224.531V207.204Z",
    fill: "#FFA412"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.433 207.204H263.168V201.15H262.433V207.204Z",
    fill: "#FFA412"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.999 207.204H264.736V201.15H263.999V207.204Z",
    fill: "#FFA412"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.516 207.204H266.253V201.15H265.516V207.204Z",
    fill: "#FFA412"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.391 201.172V207.182C267.3 207.196 267.209 207.202 267.114 207.202H266.654V201.15H267.114C267.209 201.15 267.3 201.158 267.391 201.172Z",
    fill: "#FFA412"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.413 201.732V206.622C268.233 206.843 267.976 207.017 267.676 207.114V201.24C267.976 201.337 268.233 201.511 268.413 201.732Z",
    fill: "#FFA412"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.983 196.414V199.832C273.983 200.104 273.884 200.357 273.713 200.567C273.535 200.788 273.278 200.962 272.978 201.061C272.885 201.09 272.79 201.114 272.691 201.128C272.6 201.142 272.507 201.15 272.414 201.15H207.575C206.739 201.15 206.05 200.593 206.008 199.899C206.007 199.877 206.006 199.854 206.006 199.832V196.414C206.006 196.392 206.007 196.368 206.008 196.347C206.047 195.704 206.639 195.181 207.389 195.106C207.45 195.1 207.512 195.096 207.575 195.096H272.414C272.507 195.096 272.6 195.104 272.691 195.118C272.79 195.131 272.885 195.155 272.978 195.185C273.278 195.284 273.535 195.457 273.713 195.679C273.884 195.888 273.983 196.141 273.983 196.414Z",
    fill: "#FFB93E"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.143 201.15H207.407C206.661 201.15 206.046 200.593 206.008 199.899C206.007 199.877 206.006 199.854 206.006 199.832V196.414C206.006 196.392 206.007 196.368 206.008 196.347C206.042 195.704 206.572 195.181 207.241 195.106C207.295 195.1 207.35 195.096 207.407 195.096H237.877L237.879 195.106C238.367 196.886 239.503 199.346 242.143 201.15Z",
    fill: "#FFA412"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.356 201.15H266.093V195.096H265.356V201.15Z",
    fill: "#FFA412"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.861 201.15H263.598V195.096H262.861V201.15Z",
    fill: "#FFA412"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.868 201.15H260.605V195.096H259.868V201.15Z",
    fill: "#FFA412"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.283 201.15H256.02V195.096H255.283V201.15Z",
    fill: "#FFA412"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.435 201.15H251.172V195.096H250.435V201.15Z",
    fill: "#FFA412"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.003 201.15H243.74V195.096H243.003V201.15Z",
    fill: "#FFA412"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.045 201.15H236.782V195.096H236.045V201.15Z",
    fill: "#FFA412"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.828 201.15H230.565V195.096H229.828V201.15Z",
    fill: "#FFA412"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.73 201.15H268.467V195.096H267.73V201.15Z",
    fill: "#FFA412"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.298 201.15H270.035V195.096H269.298V201.15Z",
    fill: "#FFA412"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.814 201.15H271.551V195.096H270.814V201.15Z",
    fill: "#FFA412"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.692 195.118V201.128C272.601 201.142 272.51 201.15 272.415 201.15H271.955V195.096H272.415C272.51 195.096 272.601 195.104 272.692 195.118Z",
    fill: "#FFA412"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.715 195.681V200.569C273.535 200.79 273.278 200.964 272.978 201.063V195.187C273.278 195.284 273.535 195.459 273.715 195.681Z",
    fill: "#FFA412"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.469 190.371V193.789C265.469 194.062 265.37 194.315 265.2 194.524C265.023 194.748 264.766 194.921 264.465 195.018C264.373 195.048 264.276 195.072 264.177 195.085C264.147 195.091 264.118 195.095 264.086 195.097C264.062 195.101 264.039 195.101 264.013 195.103L263.977 195.105C263.952 195.107 263.926 195.107 263.9 195.107H199.062C198.226 195.107 197.537 194.55 197.495 193.858C197.494 193.835 197.493 193.813 197.493 193.789V190.371C197.493 190.349 197.494 190.326 197.495 190.304C197.537 189.611 198.226 189.053 199.062 189.053H263.9C263.928 189.053 263.956 189.055 263.983 189.055C264.051 189.059 264.114 189.065 264.177 189.075C264.276 189.089 264.373 189.113 264.465 189.142C264.511 189.158 264.558 189.176 264.6 189.194C264.629 189.205 264.655 189.217 264.681 189.231L264.691 189.235C264.716 189.247 264.742 189.261 264.77 189.277L264.782 189.283C264.805 189.296 264.829 189.312 264.853 189.326C264.908 189.362 264.959 189.399 265.009 189.441L265.052 189.48L265.06 189.486L265.088 189.512L265.092 189.516L265.139 189.565C265.161 189.589 265.181 189.611 265.2 189.636C265.37 189.846 265.469 190.099 265.469 190.371Z",
    fill: "#FFB93E"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.631 195.107H198.894C198.148 195.107 197.533 194.55 197.495 193.858C197.494 193.835 197.493 193.813 197.493 193.789V190.371C197.493 190.349 197.494 190.326 197.495 190.304C197.533 189.611 198.148 189.053 198.894 189.053H229.365C229.377 189.101 229.389 189.146 229.405 189.194C229.911 190.96 231.049 193.339 233.617 195.097L233.631 195.107Z",
    fill: "#FFA412"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.84 195.107H257.577V189.053H256.84V195.107Z",
    fill: "#FFA412"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.348 195.107H255.085V189.053H254.348V195.107Z",
    fill: "#FFA412"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.358 195.107H252.095V189.053H251.358V195.107Z",
    fill: "#FFA412"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.771 195.107H247.508V189.053H246.771V195.107Z",
    fill: "#FFA412"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.924 195.107H242.661V189.053H241.924V195.107Z",
    fill: "#FFA412"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.49 195.107H235.226V189.053H234.49V195.107Z",
    fill: "#FFA412"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.528 195.107H228.265V189.053H227.528V195.107Z",
    fill: "#FFA412"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.314 195.107H222.051V189.053H221.314V195.107Z",
    fill: "#FFA412"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.218 195.107H259.955V189.053H259.218V195.107Z",
    fill: "#FFA412"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.787 195.107H261.524V189.053H260.787V195.107Z",
    fill: "#FFA412"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.301 195.107H263.038V189.053H262.301V195.107Z",
    fill: "#FFA412"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.176 189.075V195.085C264.087 195.099 263.994 195.107 263.899 195.107H263.439V189.053H263.899C263.994 189.053 264.087 189.061 264.176 189.075Z",
    fill: "#FFA412"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.199 189.633V194.521C265.022 194.744 264.765 194.918 264.464 195.015V189.139C264.765 189.238 265.022 189.412 265.199 189.633Z",
    fill: "#FFA412"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.237 184.458V187.876C270.237 188.148 270.139 188.401 269.969 188.613C269.789 188.834 269.534 189.008 269.232 189.105C269.141 189.136 269.044 189.158 268.945 189.172C268.854 189.186 268.763 189.194 268.669 189.194H203.83C203.578 189.194 203.34 189.144 203.129 189.053C202.656 188.856 202.318 188.46 202.267 187.998C202.265 187.98 202.263 187.963 202.263 187.945C202.262 187.921 202.261 187.899 202.261 187.876V184.458C202.261 184.436 202.262 184.412 202.263 184.39C202.302 183.748 202.894 183.225 203.644 183.15C203.705 183.144 203.766 183.14 203.83 183.14H268.669C268.763 183.14 268.854 183.148 268.945 183.161C269.044 183.177 269.141 183.199 269.232 183.229C269.534 183.327 269.789 183.501 269.969 183.723C270.139 183.934 270.237 184.185 270.237 184.458Z",
    fill: "#FFB93E"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.397 189.194H203.661C203.437 189.194 203.224 189.144 203.036 189.053C202.614 188.856 202.313 188.46 202.267 187.998C202.265 187.98 202.263 187.963 202.263 187.945C202.262 187.921 202.261 187.899 202.261 187.876V184.458C202.261 184.436 202.262 184.412 202.263 184.39C202.297 183.75 202.826 183.225 203.496 183.15C203.55 183.144 203.605 183.14 203.661 183.14H234.131L234.135 183.15C234.61 184.886 235.7 187.265 238.198 189.053C238.263 189.101 238.33 189.148 238.397 189.194Z",
    fill: "#FFA412"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.608 189.194H262.345V183.14H261.608V189.194Z",
    fill: "#FFA412"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.114 189.194H259.851V183.14H259.114V189.194Z",
    fill: "#FFA412"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.124 189.194H256.861V183.14H256.124V189.194Z",
    fill: "#FFA412"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.54 189.194H252.277V183.14H251.54V189.194Z",
    fill: "#FFA412"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.689 189.194H247.426V183.14H246.689V189.194Z",
    fill: "#FFA412"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.258 189.194H239.995V183.14H239.258V189.194Z",
    fill: "#FFA412"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.296 189.194H233.033V183.14H232.296V189.194Z",
    fill: "#FFA412"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.084 189.194H226.821V183.14H226.084V189.194Z",
    fill: "#FFA412"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.986 189.194H264.723V183.14H263.986V189.194Z",
    fill: "#FFA412"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.552 189.194H266.287V183.14H265.552V189.194Z",
    fill: "#FFA412"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.067 189.194H267.804V183.14H267.067V189.194Z",
    fill: "#FFA412"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.942 183.161V189.172C268.851 189.186 268.761 189.194 268.666 189.194H268.205V183.14H268.666C268.761 183.14 268.851 183.148 268.942 183.161Z",
    fill: "#FFA412"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.968 183.721V188.611C269.788 188.832 269.533 189.006 269.231 189.103V183.227C269.533 183.326 269.788 183.499 269.968 183.721Z",
    fill: "#FFA412"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.265 178.413V181.833C272.265 182.104 272.167 182.357 271.997 182.568C271.819 182.789 271.562 182.963 271.26 183.06C271.169 183.092 271.072 183.113 270.973 183.129C270.944 183.133 270.912 183.137 270.882 183.139L270.831 183.145L270.78 183.147C270.752 183.149 270.724 183.149 270.697 183.149H205.858C205.022 183.149 204.333 182.594 204.291 181.9C204.29 181.877 204.289 181.855 204.289 181.833V178.413C204.289 178.391 204.29 178.37 204.291 178.346C204.333 177.652 205.022 177.097 205.858 177.097H270.697C270.791 177.097 270.882 177.103 270.973 177.117C271.072 177.133 271.169 177.154 271.26 177.186C271.562 177.283 271.819 177.457 271.997 177.678C272.167 177.889 272.265 178.142 272.265 178.413Z",
    fill: "#FFB93E"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.425 183.149H205.69C204.944 183.149 204.329 182.594 204.291 181.9C204.29 181.877 204.289 181.855 204.289 181.833V178.413C204.289 178.391 204.29 178.37 204.291 178.346C204.329 177.652 204.944 177.097 205.69 177.097H236.16C236.646 178.875 237.778 181.333 240.411 183.139L240.425 183.149Z",
    fill: "#FFA412"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.639 183.149H264.376V177.097H263.639V183.149Z",
    fill: "#FFA412"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.145 183.149H261.882V177.097H261.145V183.149Z",
    fill: "#FFA412"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.15 183.149H258.887V177.097H258.15V183.149Z",
    fill: "#FFA412"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.567 183.149H254.304V177.097H253.567V183.149Z",
    fill: "#FFA412"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.72 183.149H249.457V177.097H248.72V183.149Z",
    fill: "#FFA412"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.286 183.149H242.023V177.097H241.286V183.149Z",
    fill: "#FFA412"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.327 183.149H235.064V177.097H234.327V183.149Z",
    fill: "#FFA412"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.111 183.149H228.848V177.097H228.111V183.149Z",
    fill: "#FFA412"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.014 183.149H266.751V177.097H266.014V183.149Z",
    fill: "#FFA412"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.583 183.149H268.32V177.097H267.583V183.149Z",
    fill: "#FFA412"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.099 183.149H269.836V177.097H269.099V183.149Z",
    fill: "#FFA412"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.974 177.117V183.129C270.883 183.143 270.792 183.149 270.697 183.149H270.237V177.097H270.697C270.792 177.097 270.883 177.103 270.974 177.117Z",
    fill: "#FFA412"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.998 177.678V182.568C271.82 182.789 271.563 182.963 271.261 183.06V177.186C271.563 177.282 271.82 177.456 271.998 177.678Z",
    fill: "#FFA412"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.53 140.544C203.53 120.357 219.895 103.992 240.083 103.992C260.272 103.992 276.637 120.357 276.637 140.544C276.637 160.733 260.272 177.099 240.083 177.099C219.895 177.099 203.53 160.733 203.53 140.544Z",
    fill: "#E2810E"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.34 140.544C200.34 120.357 216.706 103.992 236.893 103.992C257.082 103.992 273.447 120.357 273.447 140.544C273.447 160.733 257.082 177.099 236.893 177.099C216.706 177.099 200.34 160.733 200.34 140.544Z",
    fill: "#FFB93E"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.893 109.662C219.626 109.662 205.577 123.71 205.577 140.979C205.577 158.247 219.626 172.295 236.893 172.295C254.162 172.295 268.212 158.247 268.212 140.979C268.212 123.71 254.162 109.662 236.893 109.662ZM236.897 174.28C228.002 174.28 219.638 170.814 213.348 164.525C207.058 158.234 203.594 149.871 203.594 140.976C203.594 132.081 207.058 123.717 213.348 117.426C219.638 111.137 228.002 107.672 236.897 107.672C245.794 107.672 254.155 111.137 260.446 117.426C266.737 123.717 270.201 132.081 270.201 140.976C270.201 149.871 266.737 158.234 260.446 164.525C254.155 170.814 245.794 174.28 236.897 174.28Z",
    fill: "#FFA412"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.476 150.643C241.561 149.926 241.534 149.28 241.397 148.709C241.259 148.138 240.986 147.602 240.579 147.104C240.172 146.604 239.627 146.124 238.945 145.66C238.262 145.198 237.418 144.725 236.41 144.241C234.682 143.396 233.123 142.538 231.732 141.671C230.341 140.803 229.175 139.853 228.232 138.824C227.292 137.792 226.602 136.636 226.166 135.352C225.731 134.07 225.613 132.59 225.81 130.914C225.984 129.46 226.399 128.166 227.055 127.03C227.713 125.894 228.574 124.94 229.637 124.163C230.698 123.387 231.931 122.8 233.332 122.403C234.733 122.006 236.27 121.828 237.946 121.871L238.596 116.382L243.015 116.906L242.354 122.472C243.912 122.865 245.299 123.456 246.513 124.24C247.726 125.027 248.724 125.977 249.506 127.093C250.288 128.21 250.842 129.484 251.168 130.918C251.492 132.353 251.553 133.926 251.349 135.635L243.369 134.688C243.612 132.637 243.339 131.047 242.549 129.921C241.757 128.796 240.599 128.142 239.07 127.961C238.242 127.864 237.515 127.893 236.888 128.054C236.264 128.214 235.735 128.472 235.3 128.828C234.865 129.184 234.523 129.624 234.274 130.15C234.026 130.675 233.864 131.254 233.788 131.887C233.713 132.519 233.737 133.104 233.86 133.637C233.984 134.173 234.245 134.684 234.644 135.174C235.043 135.664 235.592 136.146 236.294 136.619C236.993 137.093 237.87 137.599 238.928 138.142C240.633 139.019 242.178 139.896 243.557 140.772C244.938 141.647 246.098 142.603 247.038 143.643C247.979 144.682 248.668 145.844 249.103 147.126C249.54 148.41 249.658 149.88 249.462 151.54C249.283 153.043 248.862 154.363 248.194 155.497C247.528 156.634 246.663 157.58 245.604 158.339C244.543 159.097 243.304 159.66 241.887 160.03C240.473 160.399 238.928 160.563 237.252 160.522L236.645 165.625L232.255 165.104L232.858 160.026C231.348 159.69 229.91 159.182 228.545 158.499C227.179 157.817 226.002 156.928 225.01 155.829C224.02 154.733 223.282 153.409 222.794 151.86C222.305 150.311 222.183 148.511 222.426 146.458L230.408 147.405C230.264 148.62 230.313 149.653 230.558 150.505C230.801 151.358 231.18 152.062 231.692 152.617C232.206 153.172 232.814 153.591 233.518 153.873C234.221 154.158 234.95 154.344 235.705 154.432C236.57 154.535 237.343 154.513 238.023 154.369C238.702 154.225 239.287 153.982 239.775 153.64C240.265 153.3 240.65 152.874 240.935 152.362C241.221 151.848 241.401 151.277 241.476 150.643Z",
    fill: "#FFA412"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.5569 205.391L91.5826 201.457H77.4004L77.3491 207.294L91.5569 205.391Z",
    fill: "black"
  })))), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1184 233.238L84.3236 224.676L91.0171 228.353L90.9658 233.469L84.1184 233.238Z",
    fill: "#BA8668"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5488 237.223L56.754 226.758L63.4475 227.041L63.3962 237.454L56.5488 237.223Z",
    fill: "#BA8668"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0649 230.512L66.8597 232.209C66.8597 232.209 54.5241 232.672 54.0112 232.081C53.37 231.335 55.0627 195.315 55.7038 184.053C56.8322 164.77 54.0625 153.689 55.1396 131.27L91.095 131.398C93.6596 153.766 95.6856 166.853 96.4293 183.771C96.7884 191.947 94.7624 225.036 94.4803 227.581C94.4803 227.581 93.4031 228.661 88.2483 228.661C83.3756 228.661 80.9136 226.759 80.9136 226.759L80.6828 185.287L76.2717 157.623C74.374 186.162 68.9114 197.86 67.0649 230.512Z",
    fill: "#565656"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2969 155.052C76.2969 155.052 76.8867 151.196 77.1945 149.602C77.5792 147.725 77.9895 145.025 77.9895 142.248",
    stroke: "#032230",
    strokeWidth: 1.04717,
    strokeMiterlimit: 10
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6307 242.826L77.605 242.8C77.5538 242.723 77.5281 242.646 77.5281 242.569C77.5538 242.389 77.5281 242.003 77.1434 241.335C76.6305 240.461 71.6039 239.766 70.5781 239.612C70.4499 239.586 70.3473 239.535 70.296 239.458L66.0388 234.213C65.9362 234.11 65.7823 234.033 65.6285 234.059C65.0899 234.11 63.782 234.47 63.346 234.676C63.1408 234.779 62.9613 235.396 62.7818 235.421C62.4227 235.498 59.2427 236.296 56.4986 233.827C56.3447 233.699 56.0882 233.776 55.96 233.904C54.7803 235.01 54.3443 237.89 54.2674 238.558C54.2674 238.661 54.1904 238.738 54.1135 238.815L54.0109 238.892C53.934 238.944 53.8827 239.021 53.8571 239.124L53.5237 240.666C53.498 240.821 53.575 240.975 53.7288 241.052C55.3958 241.9 59.1144 242.518 60.2685 242.697C60.4737 242.723 60.6788 242.62 60.7558 242.466L60.9866 241.926C61.0635 241.746 61.32 241.643 61.5251 241.72C63.2691 242.183 66.1157 243.597 66.7056 243.88C66.7825 243.906 66.8595 243.932 66.9364 243.932L77.246 243.906C77.4768 243.906 77.6563 243.752 77.682 243.572L77.7333 243.083C77.7333 242.98 77.7076 242.903 77.6307 242.826Z",
    fill: "#7C4E2C"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M105.532 238.947L105.506 238.921C105.455 238.844 105.404 238.767 105.429 238.69C105.455 238.51 105.404 238.124 104.968 237.481C104.403 236.658 99.3256 236.324 98.2998 236.273C98.1716 236.273 98.069 236.221 97.992 236.144L93.3758 231.233C93.2732 231.131 93.1193 231.079 92.9655 231.105C92.4269 231.208 91.1703 231.645 90.7343 231.902C90.5291 232.031 90.4009 232.648 90.2214 232.699C89.888 232.802 86.7592 233.83 83.8356 231.593C83.6817 231.465 83.4252 231.568 83.297 231.696C82.1942 232.905 81.9891 235.784 81.9378 236.478C81.9378 236.581 81.8865 236.658 81.7839 236.736L81.6813 236.813C81.6044 236.864 81.5531 236.967 81.5275 237.044L81.3223 238.612C81.2966 238.767 81.3992 238.895 81.5531 238.972C83.2714 239.692 87.0413 240.027 88.1954 240.129C88.4005 240.155 88.6057 240.027 88.657 239.872L88.8621 239.332C88.9391 239.152 89.1699 239.024 89.4007 239.075C91.1959 239.409 94.1195 240.618 94.7094 240.849C94.7863 240.875 94.8633 240.901 94.9402 240.875L105.199 240.078C105.429 240.052 105.609 239.898 105.609 239.718L105.634 239.23C105.634 239.075 105.609 238.998 105.532 238.947Z",
    fill: "#7C4E2C"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1931 89.1046L70.6545 96.4578L71.1931 89.1046Z",
    stroke: "#D6B929",
    strokeWidth: 4.18868,
    strokeMiterlimit: 10
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6079 99.6969V91.5466",
    stroke: "#D6B929",
    strokeWidth: 4.18868,
    strokeMiterlimit: 10
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M118.203 93.656C119.075 91.2392 112.535 91.702 111.637 91.8048L101.815 102.218L97.4551 90.4421L87.7354 96.2784C87.7354 96.2784 93.7108 113.402 98.6861 115.484C105.354 118.235 114.689 100.932 117.356 95.6614C117.895 94.5301 117.895 94.5301 118.203 93.656Z",
    fill: "#BA8668"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7111 95.6336C99.429 95.9164 97.9928 96.6363 97.6081 96.8934C96.1719 97.819 90.7607 99.7216 90.7607 99.7216L89.94 131.011L54.3693 131.551L56.8056 98.616L52.728 97.5362C50.8302 93.4482 51.0866 85.0151 53.2665 81.4928C57.7289 74.2167 65.1662 74.4224 71.1417 68.8689C71.1417 68.8689 72.8086 76.8906 77.707 76.6078C82.5797 76.325 81.7847 71.1571 81.7847 71.1571C85.3238 74.9623 90.9402 76.6335 94.864 80.2073C97.7876 82.8555 97.7876 87.2262 98.0697 88.846C98.5827 91.957 99.429 94.2709 99.7111 95.6336Z",
    fill: "#FFC600"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M110.483 98.8455C111.662 99.5397 112.945 100.362 114.278 100.851C117.022 96.1716 118.997 92.5721 119.125 92.3921C120.843 91.3637 123.254 88.9984 124.588 87.5329C125.152 86.9158 126.357 84.319 126.742 82.7507C126.947 81.8508 126.845 80.8481 126.845 80.8481C126.845 80.8481 127.05 79.0998 126.87 78.8427C126.409 78.1228 125.742 78.637 125.742 78.637C125.742 78.637 126.46 76.3488 125.896 76.2716C125.537 76.2459 124.921 76.3745 124.613 76.8887C122.716 80.0768 120.177 83.1106 118.74 83.0592C117.304 83.0078 119.228 79.5883 119.176 78.4056C119.125 77.2486 117.33 75.4232 117.022 77.2229C116.586 79.794 116.099 80.6167 115.33 82.0308C114.586 83.4449 114.073 84.7047 114.073 84.7047L112.483 90.4639L107.405 96.9943C108.405 97.6114 109.431 98.2284 110.483 98.8455Z",
    fill: "#BA8668"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6829 57.4813C88.6059 57.7126 88.5033 57.8926 88.4008 58.0469C88.2469 57.4812 88.1187 56.8899 88.0161 56.3243C88.17 56.1957 88.3238 56.1443 88.4777 56.1957C88.7598 56.2986 88.8624 56.8899 88.6829 57.4813Z",
    fill: "black"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1967 59.3559C92.0941 59.8186 91.9146 60.1786 91.735 60.3329C91.5812 60.05 91.4529 59.7158 91.4273 59.3559C91.4273 59.2787 91.4016 59.2016 91.3503 59.1502C91.4786 58.5588 91.7607 58.096 91.9915 58.1475C92.2223 58.1732 92.3249 58.7131 92.1967 59.3559Z",
    fill: "black"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2735 56.3475C94.2735 56.9388 94.0427 57.5301 93.7862 58.0701C93.4015 58.9699 93.0169 59.8698 92.6322 60.7697C92.6065 60.8468 92.5552 60.9497 92.5039 61.0268C92.6322 60.2298 92.7348 59.4327 92.786 58.6357C92.8886 56.6303 92.6065 54.5734 91.8884 52.748C90.9908 52.5937 90.6831 52.1823 89.17 51.4367C88.7597 51.2311 88.3237 50.9997 87.8877 50.7683C87.9133 50.6397 87.9646 50.5112 88.0159 50.3826C88.1698 50.0227 88.375 49.6627 88.7084 49.4827C89.1187 49.2513 89.6573 49.3285 90.0676 49.5856C90.4266 49.7913 90.7087 50.0998 90.9908 50.4083C91.0165 50.4597 91.0678 50.4854 91.0934 50.5369C91.6833 51.2311 92.2731 51.9252 92.863 52.6194L92.7604 52.2595C92.8373 52.4652 92.9399 52.6708 93.0169 52.8508C93.2733 53.4422 93.5298 54.0335 93.7606 54.6249C94.0427 55.1648 94.2735 55.7561 94.2735 56.3475Z",
    fill: "black"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8104 77.9979C82.1948 79.5148 80.7586 80.4918 78.3735 79.9776C75.5268 79.3863 74.2702 77.8437 72.5519 75.9925C71.4492 74.8098 69.218 70.8247 70.5259 69.8991C72.2955 68.665 73.4239 66.5567 74.3215 64.1656C74.7831 62.9315 75.1935 61.6203 75.6294 60.3348C75.6551 60.2834 75.6551 60.2062 75.6807 60.1548C75.8346 59.6663 75.9885 59.2035 76.168 58.7407C76.168 58.7407 76.8861 59.692 81.092 63.1629C85.2979 66.6339 84.2977 68.9992 84.2977 68.9992C84.2208 69.3592 84.1438 69.6934 84.0413 69.9505C83.5796 71.2618 82.9898 71.5446 83.99 73.0872C84.0925 73.2415 84.1951 73.3957 84.2977 73.55C85.2466 74.9641 85.0414 76.8409 83.8104 77.9979Z",
    fill: "#BA8668"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6843 57.4813C88.6074 57.7126 88.5048 57.8926 88.4022 58.0469C88.197 58.304 87.9662 58.4582 87.761 58.3811C87.4276 58.2783 87.325 57.6869 87.5302 57.0956C87.6328 56.7614 87.8123 56.4785 88.0175 56.3243C88.1714 56.1957 88.3252 56.1443 88.4791 56.1957C88.7612 56.2986 88.8638 56.8899 88.6843 57.4813Z",
    fill: "#BA8668"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9147 52.7506C91.0171 52.5964 90.7093 52.185 89.1962 51.4394C88.7859 51.2337 88.3499 51.0023 87.9139 50.7709C86.0674 49.8454 84.0927 49.0226 82.2718 49.8454C80.887 50.4624 82.3744 52.005 81.9897 53.522C81.8102 54.2676 80.3228 56.9929 79.7329 58.227C79.579 58.5612 79.0918 58.4327 79.0918 58.0727L79.0661 56.2987C78.8866 54.6789 77.8607 52.7506 76.1425 53.0592C75.2705 53.2134 74.6037 53.9333 74.3985 54.8075C73.9626 56.7615 75.0397 58.3556 75.6808 60.0524C75.7065 60.0782 75.7065 60.1296 75.7065 60.1553C75.8604 59.6668 76.0142 59.204 76.1938 58.7412C76.1938 58.7412 76.9118 59.6925 81.1178 63.1634C85.3237 66.6344 84.3235 68.9997 84.3235 68.9997C84.2466 69.3597 84.1696 69.6939 84.067 69.951C82.1949 69.154 80.451 67.7913 79.1943 66.2487C78.2454 65.0917 77.3735 62.932 76.3476 61.2608C76.2194 61.0552 75.9886 60.7466 75.7321 60.4381C75.7065 60.4124 75.6808 60.3867 75.6808 60.361C75.0653 59.5639 74.296 58.5612 74.2703 58.1242C74.0908 55.3988 73.4753 54.4475 74.5524 51.9536C75.6552 49.434 81.4512 48.3541 84.0927 47.6857C86.6829 47.0172 89.7604 48.0713 91.0427 50.411C91.0684 50.4624 91.094 50.4881 91.1197 50.5395L90.1708 49.8196C90.9145 50.6938 91.4787 51.6965 91.9147 52.7506Z",
    fill: "#BA8668"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1967 59.3559C92.0941 59.8186 91.9146 60.1786 91.735 60.3329C91.5812 60.05 91.4529 59.7158 91.4273 59.3559C91.4273 59.2787 91.4016 59.2016 91.3503 59.1502C91.4786 58.5588 91.7607 58.096 91.9915 58.1475C92.2223 58.1732 92.3249 58.7131 92.1967 59.3559Z",
    fill: "#BA8668"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5315 49.0983C97.0186 51.6951 95.326 52.8264 93.5051 52.8521C93.3512 52.8521 93.1974 52.8521 93.0691 52.8521C92.5819 52.8521 92.2228 52.8264 91.9407 52.7492C91.0431 52.595 90.7354 52.1836 89.2223 51.438C88.8119 51.2323 88.3759 51.0009 87.94 50.7695C86.0935 49.8439 84.1188 49.0212 82.2979 49.8439C80.913 50.461 82.4005 52.0036 82.0158 53.5205C81.8363 54.2661 80.3488 56.9915 79.759 58.2256C79.6051 58.5598 79.1178 58.4313 79.1178 58.0713L79.0922 56.2973C78.9127 54.6775 77.8868 52.7492 76.1686 53.0578C75.2966 53.212 74.6298 53.9319 74.4246 54.8061C73.9887 56.7601 75.0658 58.3541 75.7069 60.051C75.7326 60.0767 75.7326 60.1282 75.7326 60.1539C75.7326 60.231 75.7582 60.3081 75.7326 60.411C75.6813 61.208 75.0658 62.7249 74.3734 64.1904V64.1647C74.04 60.1796 73.8861 59.4083 73.2449 57.5571C72.809 56.2459 72.296 53.2377 72.5782 51.078C72.9372 48.4813 73.7579 43.9819 79.0152 43.0821C80.9387 42.7478 81.9902 42.6964 84.2213 43.0049C87.9143 43.4677 90.1455 43.7505 93.4538 44.1876C95.8132 44.5218 98.2239 45.6017 97.5315 49.0983Z",
    fill: "black"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6843 57.4813C88.6074 57.7126 88.5048 57.8926 88.4022 58.0469C88.197 58.304 87.9662 58.4582 87.761 58.3811C87.4276 58.2783 87.325 57.6869 87.5302 57.0956C87.6328 56.7614 87.8123 56.4785 88.0175 56.3243C88.1714 56.1957 88.3252 56.1443 88.4791 56.1957C88.7612 56.2986 88.8638 56.8899 88.6843 57.4813Z",
    fill: "#9F6647"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1967 59.357C92.0941 59.8198 91.9146 60.1798 91.735 60.334C91.5812 60.0512 91.4529 59.717 91.3503 59.1256C91.4786 58.5343 91.7607 58.0715 91.9915 58.1229C92.2223 58.1743 92.3249 58.7143 92.1967 59.357Z",
    fill: "#9F6647"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5556 69.1799C79.9398 67.4316 77.7855 65.0148 76.4006 62.1867L76.6314 62.0581C78.0163 64.8348 80.1193 67.2259 82.7095 68.9485L82.5556 69.1799Z",
    fill: "#9F6647"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6594 61.5924C92.6081 61.5153 92.5312 61.4381 92.4799 61.361C92.5056 61.2582 92.5312 61.1296 92.5569 61.0268C92.6851 60.2297 92.7877 59.4327 92.839 58.6357C92.9415 56.6302 92.6594 54.5734 91.9414 52.7479C91.0438 52.5937 90.736 52.1823 89.2229 51.4367C88.8126 51.231 88.3766 50.9996 87.9406 50.7682C86.0941 49.8426 84.1194 49.0199 82.2985 49.8426C80.9137 50.4597 82.4011 52.0023 82.0164 53.5193C81.8369 54.2649 80.3495 56.9902 79.7596 58.2243C79.6057 58.5585 79.1185 58.43 79.1185 58.07L79.0928 56.296C78.9133 54.6505 77.8875 52.7479 76.1692 53.0565C75.2972 53.2107 74.6304 53.9306 74.4253 54.8048C73.9893 56.7588 75.0664 58.3529 75.7076 60.0498C75.7332 60.0755 75.7332 60.1269 75.7332 60.1526C75.8871 59.6641 76.041 59.2013 76.2205 58.7385C76.2205 58.7385 76.9386 59.6898 81.1445 63.1607C85.3504 66.6317 84.3502 68.997 84.3502 68.997C84.2733 69.357 84.1963 69.6912 84.0937 69.9483C84.5297 70.1283 84.9657 70.2826 85.376 70.4111C86.5044 70.7196 87.7354 71.0025 88.7613 70.4625C89.7358 69.9483 90.1974 68.8171 90.5821 67.7886C90.9925 66.7088 91.3771 65.6032 91.7105 64.4977C92.403 64.0092 93.2236 63.3921 93.198 62.6208C93.1724 62.2094 92.8902 61.8752 92.6594 61.5924ZM88.6843 57.4787C88.6074 57.7101 88.5048 57.8901 88.4022 58.0443C88.1971 58.3014 87.9663 58.4557 87.7611 58.3786C87.4277 58.2757 87.3251 57.6844 87.5303 57.093C87.6329 56.7588 87.8124 56.476 88.0175 56.3217C88.1714 56.1932 88.3253 56.1417 88.4792 56.1932C88.7613 56.296 88.8639 56.8874 88.6843 57.4787ZM92.1978 59.3556C92.0952 59.8184 91.9157 60.1783 91.7362 60.3326C91.5823 60.0498 91.4541 59.7155 91.3515 59.1242C91.4797 58.5328 91.7618 58.07 91.9926 58.1215C92.2235 58.1729 92.326 58.7128 92.1978 59.3556Z",
    fill: "#BA8668"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M153.081 143.174L99.0199 143.945C95.4808 143.997 92.5828 141.169 92.5315 137.621L91.7622 83.4227C91.7109 79.8746 94.5319 76.9693 98.071 76.9179L152.132 76.1466C155.671 76.0951 158.569 78.9233 158.621 82.4714L159.39 136.669C159.441 140.217 156.62 143.123 153.081 143.174Z",
    fill: "#82AAD1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9862_162966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 71,
    width: 69,
    height: 69
  }, _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M148.894 138.982L94.8329 139.753C91.2938 139.805 88.3958 136.977 88.3445 133.429L87.5752 79.2306C87.5239 75.6826 90.3449 72.7773 93.884 72.7259L147.945 71.9545C151.484 71.9031 154.382 74.7313 154.434 78.2794L155.203 132.477C155.254 136.025 152.433 138.931 148.894 138.982Z",
    fill: "#82AAD1"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9862_162966)"
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M152.106 61.7479L163.801 138.185L87.5045 149.909L75.8101 73.4719L152.106 61.7479Z",
    fill: "url(#paint4_linear_9862_162966)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.693,
    y: 59.3345,
    width: 16.5326,
    height: 63.1246,
    transform: "rotate(34.0084 100.693 59.3345)",
    fill: "url(#paint5_linear_9862_162966)",
    fillOpacity: 0.45
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162.782,
    y: 80.5847,
    width: 16.5326,
    height: 63.1246,
    transform: "rotate(34.0084 162.782 80.5847)",
    fill: "url(#paint6_linear_9862_162966)",
    fillOpacity: 0.45
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.503,
    y: 58.8191,
    width: 19.9517,
    height: 102.076,
    transform: "rotate(34.0084 136.503 58.8191)",
    fill: "url(#paint7_linear_9862_162966)",
    fillOpacity: 0.45
  })))), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M134 100.667C134 100.093 133.772 99.5417 133.365 99.1353C132.959 98.729 132.408 98.5007 131.833 98.5007H106.722L111.705 93.5391C112.113 93.1311 112.342 92.5777 112.342 92.0007C112.342 91.4237 112.113 90.8704 111.705 90.4624C111.297 90.0544 110.744 89.8252 110.167 89.8252C109.59 89.8252 109.036 90.0544 108.628 90.4624L99.9616 99.1291C99.6609 99.4337 99.4573 99.8207 99.3763 100.241C99.2953 100.661 99.3406 101.096 99.5066 101.491C99.6691 101.886 99.9451 102.225 100.3 102.464C100.655 102.703 101.072 102.832 101.5 102.834H131.833C132.408 102.834 132.959 102.606 133.365 102.199C133.772 101.793 134 101.242 134 100.667ZM142.493 108.511C142.331 108.115 142.055 107.776 141.7 107.537C141.345 107.298 140.928 107.17 140.5 107.167H110.167C109.592 107.167 109.041 107.396 108.634 107.802C108.228 108.208 108 108.759 108 109.334C108 109.909 108.228 110.46 108.634 110.866C109.041 111.272 109.592 111.501 110.167 111.501H135.278L130.295 116.462C130.092 116.664 129.931 116.903 129.821 117.167C129.711 117.432 129.654 117.715 129.654 118.001C129.654 118.287 129.711 118.57 129.821 118.834C129.931 119.098 130.092 119.338 130.295 119.539C130.496 119.742 130.736 119.903 131 120.013C131.264 120.123 131.547 120.18 131.833 120.18C132.119 120.18 132.402 120.123 132.666 120.013C132.931 119.903 133.17 119.742 133.372 119.539L142.038 110.872C142.339 110.568 142.543 110.181 142.624 109.76C142.704 109.34 142.659 108.905 142.493 108.511Z",
    fill: "#A2E6FF"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4528 119.005C88.4528 119.005 89.7095 119.082 91.6585 119.57C93.6076 120.059 94.4283 120.933 97.6853 121.396C101.404 121.91 98.6342 123.555 96.839 123.607C95.4285 123.658 94.1718 122.707 93.0178 123.195C93.2999 123.813 93.5307 124.918 97.3519 128.003C98.0443 128.543 100.609 129.803 100.609 129.803C101.327 130.266 102.866 131.166 102.558 132.117C102.481 132.348 102.096 132.477 102.096 132.477C102.096 132.477 103.071 133.017 102.712 133.968C102.558 134.328 100.147 133.66 100.147 133.66C100.147 133.66 101.096 134.431 100.814 135.125C100.737 135.331 93.582 133.531 93.582 133.531L94.9668 134.277L96.4799 134.894C96.4799 134.894 97.198 135.382 96.9416 136.051C96.839 136.308 95.3515 135.948 93.6589 135.434C91.043 134.611 89.4017 133.505 87.863 132.22C86.0165 130.677 85.2984 130.343 83.4262 127.823C83.1954 127.515 82.9646 127.155 82.7338 126.769C78.2201 124.481 65.0639 117.693 61.3965 115.02C56.9341 112.089 52.2666 95.9938 52.2666 95.9938L63.2943 96.2509L68.962 107.795L85.6061 119.442L88.4528 119.005Z",
    fill: "#BA8668"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9862_162966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 51,
    width: 31,
    height: 38
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178 51H208.565V88.5703H178V51Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9862_162966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.243 63.9799C177.784 73.5195 175.824 83.2951 180.808 86.4005C180.927 86.475 183.293 87.9134 183.417 87.978C188.476 90.6287 195.22 84.0653 201.526 74.7517C207.662 65.6866 210.838 57.0611 206.686 53.4515C206.468 53.2627 204.444 52.0056 204.193 51.8516C199.209 48.7463 190.7 54.4377 184.243 63.9799Z",
    fill: "#E2A700"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9862_162966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 52,
    width: 29,
    height: 37
  }, _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.304 52.5803H209.04V88.6932H181.304V52.5803Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9862_162966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.567 65.8229C181.164 75.4306 179.377 85.376 183.575 88.0356C187.775 90.6928 196.373 85.0583 202.777 75.4506C209.182 65.8405 210.967 55.8975 206.769 53.2379C202.569 50.5808 193.973 56.2153 187.567 65.8229Z",
    fill: "#FFBF40"
  }))), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.813 58.9079C205.697 57.9115 205.343 57.1977 204.761 56.8347C203.58 56.094 201.423 56.7713 198.837 58.6862C196.139 60.6863 193.206 63.8899 190.791 67.4736C185.906 74.7165 183.967 82.2127 186.559 83.8353C189.15 85.4553 195.469 80.7047 200.354 73.457C202.769 69.8757 204.612 65.9924 205.413 62.8034C205.8 61.254 205.932 59.9311 205.813 58.9079ZM183.704 81.9299C183.239 77.954 185.757 71.7586 189.284 66.5281C191.805 62.7885 194.89 59.4314 197.742 57.3143C201.062 54.8513 203.828 54.1862 205.739 55.3824C207.653 56.5786 208.144 59.2828 207.158 63.2075C206.311 66.5793 204.382 70.6599 201.861 74.3995C197.016 81.5839 189.666 87.8426 185.58 85.287C184.47 84.5926 183.876 83.416 183.704 81.9299Z",
    fill: "#FFDF67"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9862_162966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 86,
    width: 30,
    height: 18
  }, _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281 86.8251H310.486V103.25H281V86.8251Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9862_162966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.564 101.96C301.485 104.238 308.671 103.523 309.833 99.6281C309.862 99.5361 310.388 97.6937 310.408 97.6018C311.241 93.749 305.331 90.676 297.599 88.4534C290.073 86.2892 283.446 85.9709 281.765 89.4241C281.676 89.6062 281.21 91.1887 281.152 91.3832C279.988 95.2767 285.643 99.6829 293.564 101.96Z",
    fill: "#E2A700"
  }))), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.564 98.9943C302.579 101.225 309.884 100.404 310.885 97.1638C311.887 93.9219 306.201 89.485 298.186 87.2561C290.173 85.0255 282.863 85.8447 281.864 89.0866C280.863 92.3286 286.549 96.7638 294.564 98.9943Z",
    fill: "#FFBF40"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.217 97.0324C298.231 97.9161 301.322 98.3373 303.676 98.1933C305.927 98.0529 307.379 97.4175 307.664 96.451C307.946 95.4809 307.068 94.1634 305.25 92.8332C303.338 91.4329 300.513 90.1262 297.501 89.2425C294.472 88.3551 291.341 87.9196 288.923 88.051C286.605 88.1751 285.114 88.7979 284.831 89.759C284.225 91.8343 289.076 95.2325 295.217 97.0324ZM302.692 99.5C300.357 99.5 297.62 99.0698 294.857 98.2599C288.675 96.4474 282.63 92.727 283.604 89.4009C284.061 87.8422 285.877 86.935 288.853 86.773C291.417 86.6399 294.697 87.088 297.86 88.015C301.055 88.9527 303.95 90.2954 306.004 91.8001C308.351 93.5172 309.349 95.2487 308.892 96.8092C308.434 98.3697 306.657 99.2894 303.757 99.4694C303.413 99.4892 303.057 99.5 302.692 99.5Z",
    fill: "#FFDF67"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9862_162966",
    x1: -106.434,
    y1: 2.77621,
    x2: -114.392,
    y2: 269.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447011,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726968,
    stopColor: "#C6F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9862_162966",
    x1: -42.3869,
    y1: 186.833,
    x2: -40.8943,
    y2: 258.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9862_162966",
    x1: 384.652,
    y1: 175.142,
    x2: 383.343,
    y2: 232.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9862_162966",
    x1: 309.511,
    y1: 232.423,
    x2: 309.511,
    y2: 282.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9862_162966",
    x1: 115.593,
    y1: 78.2034,
    x2: 136.28,
    y2: 212.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9862_162966",
    x1: 108.959,
    y1: 59.3345,
    x2: 108.959,
    y2: 122.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9862_162966",
    x1: 171.049,
    y1: 80.5847,
    x2: 171.049,
    y2: 143.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9862_162966",
    x1: 146.479,
    y1: 58.8191,
    x2: 146.479,
    y2: 160.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLoadingBottomBackground);
export default __webpack_public_path__ + "static/media/transaction-loading-bottom-background.5bea52ebb9aed62c659b6c1b08cf9777.svg";
export { ForwardRef as ReactComponent };